"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[80],{

/***/ 49279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useRouter; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97334);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(querystring__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_urlHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83485);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var useRouter = function useRouter() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var customPush = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function (url, as, options) {
    var params = router.query;

    if (typeof url === 'string') {
      var routeWithParams = (0,utils_urlHelper__WEBPACK_IMPORTED_MODULE_4__/* .generateUrlWithQueryString */ .so)(url, params);
      router.push(routeWithParams, as, options);
    } else {
      var filteredParams = (0,utils_urlHelper__WEBPACK_IMPORTED_MODULE_4__/* .filterAllowedParams */ .fb)(params);
      var newQuery = url === null || url === void 0 ? void 0 : url.query;
      var newParms = typeof newQuery === 'string' ? (0,querystring__WEBPACK_IMPORTED_MODULE_2__.parse)(newQuery) : newQuery;

      var allParams = _objectSpread(_objectSpread({}, newParms), filteredParams);

      router.push(_objectSpread(_objectSpread({}, url), {}, {
        query: allParams
      }), as, options);
    }
  }, [router]);
  return (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    return _objectSpread(_objectSpread({}, router), {}, {
      push: customPush
    });
  }, [customPush, router]);
};

/***/ }),

/***/ 8400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Icons; },
  "q": function() { return /* binding */ getIcon; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/svgs/flag/arab.svg
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArab = function SvgArab(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 12c0 4.367 2.8 8.067 6.667 9.433V2.567C4.8 3.933 2 7.633 2 12Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 2c-1.167 0-2.3.2-3.333.567v6.1h12.766C20.067 4.8 16.367 2 12 2Z",
    fill: "#699635"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M21.433 8.667H8.667v6.666h12.766A9.997 9.997 0 0 0 22 12c0-1.167-.2-2.3-.567-3.333Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M8.667 15.333v6.1A10 10 0 0 0 12 22a9.967 9.967 0 0 0 9.433-6.667H8.667Z",
    fill: "#3E4347"
  })));
};
/* harmony default export */ var arab = (SvgArab);
;// CONCATENATED MODULE: ./src/svgs/flag/brazil.svg
var brazil_path, brazil_path2, brazil_path3, brazil_path4, _path5, _path6;
function brazil_extends() { brazil_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return brazil_extends.apply(this, arguments); }

var SvgBrazil = function SvgBrazil(props) {
  return /*#__PURE__*/react.createElement("svg", brazil_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), brazil_path || (brazil_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.833 10.267C21.033 5.567 16.933 2 12 2s-9.033 3.567-9.833 8.267L12 5.333l9.833 4.934ZM2.167 13.733C2.967 18.433 7.067 22 12 22s9.033-3.567 9.833-8.267L12 18.667l-9.833-4.934Z",
    fill: "#699635"
  })), brazil_path2 || (brazil_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m12 5.333-9.833 4.934A9.857 9.857 0 0 0 2 12c0 .6.067 1.167.167 1.733L12 18.667l9.833-4.934c.1-.566.167-1.133.167-1.733 0-.6-.067-1.167-.167-1.733L12 5.333Z",
    fill: "#FFE62E"
  })), brazil_path3 || (brazil_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M10 10.8a7.278 7.278 0 0 0-2.967.633C7 11.633 7 11.8 7 12c0 2.767 2.233 5 5 5 1.867 0 3.5-1.033 4.367-2.533C15.133 12.3 12.733 10.8 10 10.8Z",
    fill: "#428BC1"
  })), brazil_path4 || (brazil_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M16.933 12.8A6.46 6.46 0 0 0 17 12c0-2.767-2.233-5-5-5-1.967 0-3.667 1.133-4.5 2.8a8.892 8.892 0 0 1 2.5-.367 8.803 8.803 0 0 1 6.933 3.367Z",
    fill: "#428BC1"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M10 9.433c-.867 0-1.7.134-2.5.367-.233.5-.4 1.033-.467 1.633.9-.4 1.9-.633 2.967-.633 2.733 0 5.133 1.467 6.366 3.633.3-.5.467-1.066.567-1.633A8.803 8.803 0 0 0 10 9.433Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M8.667 12.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM10 14.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM12 14.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM12 15.667A.333.333 0 1 0 12 15a.333.333 0 0 0 0 .667ZM14.667 14.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.667 15.667a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667ZM13.333 15a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667ZM8.667 13.667a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var brazil = (SvgBrazil);
;// CONCATENATED MODULE: ./src/svgs/flag/china.svg
var china_path, china_path2;
function china_extends() { china_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return china_extends.apply(this, arguments); }

var SvgChina = function SvgChina(props) {
  return /*#__PURE__*/react.createElement("svg", china_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), china_path || (china_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#ED4C5C"
  })), china_path2 || (china_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m8.667 10.8 2.666 1.867-1-3.067L13 7.667H9.7l-1.033-3-1 3H4.333L7 9.6l-1 3.067L8.667 10.8ZM13.1 13.1l-.767.167.734.3v.766l.5-.566.733.266-.433-.633.466-.6-.766.167-.467-.634v.767ZM14.233 10.833l-.566.5.766-.066.334.733.133-.767.767-.066-.667-.4.167-.767-.567.5-.667-.4.3.733ZM14.433 8.233l.234.767.233-.733h.767l-.6-.467.233-.767-.633.467-.6-.5.233.767-.633.433.766.033ZM13.1 5.567v.766l.467-.633.766.167-.466-.6.433-.634-.733.3-.5-.6V5.1l-.734.3.767.167Z",
    fill: "#FFE62E"
  })));
};
/* harmony default export */ var china = (SvgChina);
;// CONCATENATED MODULE: ./src/svgs/flag/english.svg
var english_path, english_path2, english_path3, english_path4, english_path5, english_path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function english_extends() { english_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return english_extends.apply(this, arguments); }

var SvgEnglish = function SvgEnglish(props) {
  return /*#__PURE__*/react.createElement("svg", english_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), english_path || (english_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.333 3.533C15.767 2.567 13.967 2 12 2v1.533h5.333Z",
    fill: "#ED4C5C"
  })), english_path2 || (english_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 5.067h7.2c-.567-.567-1.2-1.1-1.867-1.534H12v1.534Z",
    fill: "#fff"
  })), english_path3 || (english_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M12 6.6h8.433a11.097 11.097 0 0 0-1.2-1.533H12V6.6Z",
    fill: "#ED4C5C"
  })), english_path4 || (english_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M12 8.133h9.233c-.233-.533-.5-1.066-.8-1.533H12v1.533Z",
    fill: "#fff"
  })), english_path5 || (english_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M12 9.667h9.733a11.77 11.77 0 0 0-.5-1.534H12v1.534Z",
    fill: "#ED4C5C"
  })), english_path6 || (english_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M12 11.233h9.967c-.034-.533-.134-1.033-.234-1.533H12v1.533Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M21.967 11.233H12V12H2c0 .267 0 .5.033.767h19.934C22 12.5 22 12.267 22 12s0-.533-.033-.767Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M2.267 14.3h19.466c.134-.5.2-1 .234-1.533H2.033c.034.5.1 1.033.234 1.533Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M2.767 15.833h18.466c.2-.5.367-1 .5-1.533H2.267c.133.533.3 1.033.5 1.533Z",
    fill: "#ED4C5C"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M3.567 17.367h16.866c.3-.5.567-1 .8-1.534H2.767c.233.534.5 1.034.8 1.534Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M4.767 18.9h14.466c.434-.467.867-1 1.2-1.533H3.567c.333.566.766 1.066 1.2 1.533Z",
    fill: "#ED4C5C"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M6.633 20.433h10.734c.7-.433 1.3-.966 1.866-1.533H4.767c.566.6 1.2 1.1 1.866 1.533Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M12 22c1.967 0 3.8-.567 5.367-1.567H6.633C8.2 21.433 10.033 22 12 22Z",
    fill: "#ED4C5C"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M6.667 3.533c-.7.434-1.334.967-1.9 1.534-.467.466-.867 1-1.2 1.533-.3.5-.6 1-.8 1.533-.2.5-.367 1-.5 1.534-.134.5-.2 1-.234 1.533C2 11.467 2 11.733 2 12h10V2c-1.967 0-3.767.567-5.333 1.533Z",
    fill: "#428BC1"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "m9.667 2.333.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM11 4.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM8.333 4.333l.167.5H9l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM9.667 6.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM7 6.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM4.333 6.333l.167.5H5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM11 8.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM8.333 8.333l.167.5H9l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM5.667 8.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM9.667 10.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM7 10.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM4.333 10.333l.167.5H5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM5.267 5.667l.4-.3.4.3-.167-.5.4-.334h-.5l-.133-.5-.167.5h-.467l.4.3-.166.534ZM2.6 9.667l.4-.3.4.3-.167-.5.4-.334h-.466L3 8.333l-.167.5H2.5c0 .034-.033.067-.033.1l.266.2-.133.534Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var english = (SvgEnglish);
;// CONCATENATED MODULE: ./src/svgs/flag/france.svg
var france_path, france_path2, france_path3;
function france_extends() { france_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return france_extends.apply(this, arguments); }

var SvgFrance = function SvgFrance(props) {
  return /*#__PURE__*/react.createElement("svg", france_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), france_path || (france_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 12c0 4.367 2.8 8.067 6.667 9.433V2.567C4.8 3.933 2 7.633 2 12Z",
    fill: "#428BC1"
  })), france_path2 || (france_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M22 12a9.967 9.967 0 0 0-6.667-9.433v18.866A9.967 9.967 0 0 0 22 12Z",
    fill: "#ED4C5C"
  })), france_path3 || (france_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M8.667 21.433A9.997 9.997 0 0 0 12 22c1.167 0 2.3-.2 3.333-.567V2.567A9.853 9.853 0 0 0 12 2c-1.2 0-2.3.2-3.333.567v18.866Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var france = (SvgFrance);
;// CONCATENATED MODULE: ./src/svgs/flag/hongkong.svg
var hongkong_path, hongkong_path2, hongkong_path3, hongkong_path4, hongkong_path5, hongkong_path6, hongkong_path7, hongkong_path8, hongkong_path9, hongkong_path10, hongkong_path11;
function hongkong_extends() { hongkong_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hongkong_extends.apply(this, arguments); }

var SvgHongkong = function SvgHongkong(props) {
  return /*#__PURE__*/react.createElement("svg", hongkong_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hongkong_path || (hongkong_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.712 21.75c5.523 0 10-4.477 10-10s-4.477-10-10-10c-5.522 0-10 4.477-10 10s4.478 10 10 10Z",
    fill: "#ED4C5C"
  })), hongkong_path2 || (hongkong_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.046 10.35c.233-.6.8-.7 1.1-1.467.133-.333-.1-1 .033-1.333.3-.767 1.067-.633 1.067-.633-1.367-.5-2.9.2-3.4 1.533s.2 2.833 1.566 3.3c-.366-.4-.566-.867-.366-1.4Z",
    fill: "#fff"
  })), hongkong_path3 || (hongkong_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M11.18 8.483a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z",
    fill: "#ED4C5C"
  })), hongkong_path4 || (hongkong_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M9.913 11.683c-.5-.4-.434-.966-1.1-1.466-.3-.234-1-.2-1.3-.434-.667-.5-.267-1.2-.267-1.2-.9 1.134-.7 2.767.467 3.634 1.133.866 2.8.666 3.7-.434-.534.2-1.034.234-1.5-.1Z",
    fill: "#fff"
  })), hongkong_path5 || (hongkong_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M8.012 11.217a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z",
    fill: "#ED4C5C"
  })), hongkong_path6 || (hongkong_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M10.879 13.15c-.533.367-1.067.1-1.767.567-.3.2-.5.866-.8 1.066-.7.467-1.266-.1-1.266-.1.8 1.2 2.466 1.5 3.666.7 1.2-.8 1.534-2.4.734-3.6.033.567-.1 1.034-.567 1.367Z",
    fill: "#fff"
  })), hongkong_path7 || (hongkong_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M9.412 14.517c.1-.134.3-.167.434-.067.133.1.166.3.066.433-.1.134-.3.167-.433.067a.316.316 0 0 1-.067-.433Z",
    fill: "#ED4C5C"
  })), hongkong_path8 || (hongkong_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M12.58 12.717c.166.6-.234 1.033 0 1.833.1.333.666.733.766 1.1.233.8-.5 1.133-.5 1.133 1.4-.4 2.2-1.833 1.8-3.2-.4-1.366-1.867-2.166-3.267-1.766.6.1 1.034.333 1.2.9Z",
    fill: "#fff"
  })), hongkong_path9 || (hongkong_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M13.613 14.483a.316.316 0 0 1 .066-.433.316.316 0 0 1 .434.067c.1.133.066.333-.067.433-.167.133-.333.1-.433-.067Z",
    fill: "#ED4C5C"
  })), hongkong_path10 || (hongkong_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M12.68 10.983c.666.034.933.534 1.766.567.367 0 .933-.4 1.3-.4.833.033.933.8.933.8.067-1.433-1.1-2.633-2.533-2.667-1.467-.033-2.667 1.067-2.733 2.5.3-.5.7-.833 1.266-.8Z",
    fill: "#fff"
  })), hongkong_path11 || (hongkong_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M14.88 10.583c-.168.067-.334-.033-.4-.2-.068-.166.032-.333.2-.4.166-.066.332.034.4.2.066.167-.034.367-.2.4Z",
    fill: "#ED4C5C"
  })));
};
/* harmony default export */ var hongkong = (SvgHongkong);
;// CONCATENATED MODULE: ./src/svgs/flag/indo.svg
var indo_path, indo_path2;
function indo_extends() { indo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return indo_extends.apply(this, arguments); }

var SvgIndo = function SvgIndo(props) {
  return /*#__PURE__*/react.createElement("svg", indo_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), indo_path || (indo_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 22c5.533 0 10-4.467 10-10H2c0 5.533 4.467 10 10 10Z",
    fill: "#F9F9F9"
  })), indo_path2 || (indo_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 2C6.467 2 2 6.467 2 12h20c0-5.533-4.467-10-10-10Z",
    fill: "#ED4C5C"
  })));
};
/* harmony default export */ var indo = (SvgIndo);
;// CONCATENATED MODULE: ./src/svgs/flag/korea.svg
var korea_path, korea_path2, korea_path3, korea_path4, korea_path5;
function korea_extends() { korea_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return korea_extends.apply(this, arguments); }

var SvgKorea = function SvgKorea(props) {
  return /*#__PURE__*/react.createElement("svg", korea_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), korea_path || (korea_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#F5F5F5"
  })), korea_path2 || (korea_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M9.133 12.567c.934.633 2.234.366 2.867-.567.633-.933 1.9-1.2 2.867-.567.9.6 1.166 1.767.666 2.667 1.1-1.867.6-4.3-1.266-5.533C12.367 7.3 9.8 7.8 8.533 9.7a.729.729 0 0 1-.1.167c-.467.966-.167 2.1.7 2.7Z",
    fill: "#ED4C5C"
  })), korea_path3 || (korea_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M15.433 14.3c.034-.067.067-.133.1-.167-.033.034-.066.1-.1.167Z",
    fill: "#003478"
  })), korea_path4 || (korea_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M14.867 11.433c-.934-.633-2.234-.366-2.867.567-.633.933-1.9 1.2-2.867.567A2.028 2.028 0 0 1 8.467 9.9c-1.134 1.867-.6 4.3 1.266 5.533 1.9 1.267 4.467.767 5.734-1.133a.726.726 0 0 1 .1-.167c.466-.966.166-2.1-.7-2.7Z",
    fill: "#428BC1"
  })), korea_path5 || (korea_path5 = /*#__PURE__*/react.createElement("path", {
    d: "m3.933 9.1 2.3-3.433L6 5.5l-.233-.133-2.3 3.433.233.133.233.167ZM4.567 9.533l.233.134 2.267-3.434-.2-.133-.234-.167-2.3 3.434.234.166ZM7.467 6.5 5.2 9.933l.233.167.234.133L7.933 6.8 7.7 6.667 7.467 6.5ZM17.5 15.5l.233.167 1.067-1.6-.233-.167-.234-.133-1.066 1.6.233.133ZM20.067 14.9 19 16.5l.233.167.234.133 1.066-1.6-.233-.133-.233-.167ZM18.6 16.233l1.067-1.6-.234-.166-.233-.134-1.067 1.6.234.134.233.166ZM17.367 15.733l-.234-.133-1.066 1.6.233.133.233.167 1.067-1.6-.233-.167ZM18.2 16.3l-.2-.133-1.067 1.6.2.133.233.167 1.067-1.6-.233-.167ZM18.833 16.733l-1.066 1.6.233.167.233.133 1.067-1.6-.233-.166-.234-.134ZM3.7 15.067l-.233.133 2.3 3.433L6 18.5l.233-.167-2.3-3.433-.233.167ZM5.8 16.3l-.233.167 1.066 1.6.234-.167.2-.133L6 16.167l-.2.133ZM5.433 13.9l-.233.167L7.467 17.5l.233-.167.233-.133-2.266-3.433-.234.133ZM4.333 14.633l1.067 1.6.233-.166.234-.134-1.067-1.6-.233.134-.234.166ZM19.067 7.133l.233-.166-1.067-1.6L18 5.5l-.233.167 1.066 1.6.234-.134ZM17.367 8.267 17.6 8.1l-1.067-1.6-.233.167-.233.133 1.066 1.6.234-.133ZM19 7.5l1.067 1.6.233-.167.233-.133-1.066-1.6-.234.133L19 7.5ZM19.433 9.533l.233-.166-2.3-3.434-.233.167-.2.133L19.2 9.667l.233-.134ZM18.567 10.1l.233-.167-1.067-1.6-.233.167-.233.133 1.066 1.6.234-.133Z",
    fill: "#3E4347"
  })));
};
/* harmony default export */ var korea = (SvgKorea);
;// CONCATENATED MODULE: ./src/svgs/flag/portugal.svg
var portugal_path, portugal_path2, portugal_path3, portugal_path4, portugal_path5, portugal_path6, portugal_path7, portugal_path8, portugal_path9, portugal_path10, portugal_path11, portugal_path12, portugal_path13, portugal_path14, portugal_path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function portugal_extends() { portugal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return portugal_extends.apply(this, arguments); }

var SvgPortugal = function SvgPortugal(props) {
  return /*#__PURE__*/react.createElement("svg", portugal_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), portugal_path || (portugal_path = /*#__PURE__*/react.createElement("path", {
    d: "M7 20.667V3.333C4 5.067 2 8.3 2 12s2 6.933 5 8.667Z",
    fill: "#699635"
  })), portugal_path2 || (portugal_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 2c-1.833 0-3.533.5-5 1.333v17.334C8.467 21.533 10.167 22 12 22c5.533 0 10-4.467 10-10S17.533 2 12 2Z",
    fill: "#ED4C5C"
  })), portugal_path3 || (portugal_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M7 8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Zm0 7.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z",
    fill: "#FFE62E"
  })), portugal_path4 || (portugal_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M8.367 15.9a.161.161 0 0 1-.234 0L3.567 9.867a.161.161 0 0 1 0-.234l.1-.1a.161.161 0 0 1 .233 0l4.567 6.034a.161.161 0 0 1 0 .233l-.1.1Z",
    fill: "#FFE62E"
  })), portugal_path5 || (portugal_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M7.067 7.833c.1 0 .166.067.166.167v8c0 .1-.066.167-.166.167H6.9c-.1 0-.167-.067-.167-.167V8c0-.1.067-.167.167-.167h.167Z",
    fill: "#FFE62E"
  })), portugal_path6 || (portugal_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M10.967 12.433 7 11.733v.5l3.9.7c.1 0 .167-.033.2-.133l.033-.167c0-.066-.066-.166-.166-.2ZM7 11.7 3.867 9.5c-.067-.067-.167-.033-.234.033l-.1.134c-.066.066-.033.166.034.233L7 12.3v-.6Z",
    fill: "#FFE62E"
  })), portugal_path7 || (portugal_path7 = /*#__PURE__*/react.createElement("path", {
    d: "m6.867 11.333-3.134 3.134a.161.161 0 0 0 0 .233l.134.133a.161.161 0 0 0 .233 0l2.767-2.766v-.734ZM7 9.833 2.833 11.8c-.066.033-.133.133-.066.233l.066.167c.034.067.134.133.234.067L7 10.4v-.567Z",
    fill: "#FFE62E"
  })), portugal_path8 || (portugal_path8 = /*#__PURE__*/react.createElement("path", {
    d: "m10.7 10.4-3.967-.7v.5l3.9.7c.1 0 .167-.033.2-.133l.034-.167c-.034-.1-.1-.2-.167-.2ZM6.967 14.3c-.067.033-.134.133-.067.233l.067.167c.033.067.133.133.233.067l3.333-1.534.167-.633-3.733 1.7ZM6.967 13.167 3.233 11.8v.533L6.967 13.7v-.533Z",
    fill: "#FFE62E"
  })), portugal_path9 || (portugal_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M4.367 14.267v.5L9.3 15.1c.2-.133.367-.3.533-.467l-5.466-.366Z",
    fill: "#FFE62E"
  })), portugal_path10 || (portugal_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M5.333 10.333v2.334A1.65 1.65 0 0 0 7 14.333a1.65 1.65 0 0 0 1.667-1.666v-2.334H5.333Z",
    fill: "#fff"
  })), portugal_path11 || (portugal_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M7 15a2.319 2.319 0 0 1-2.333-2.333v-3h4.666v3C9.333 13.967 8.3 15 7 15Zm-1-4v1.667c0 .566.433 1 1 1s1-.434 1-1V11H6Z",
    fill: "#ED4C5C"
  })), portugal_path12 || (portugal_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M6.7 11.133v.534c0 .1.067.166.167.166h.266c.1 0 .167-.066.167-.166V11.1h-.6v.033ZM6.7 11.967v.566c0 .1.067.167.167.167h.266c.1 0 .167-.067.167-.167v-.566h-.6ZM6.033 11.967v.566c0 .1.067.167.167.167h.267c.1 0 .166-.067.166-.167v-.566h-.6ZM7.366 11.967v.566c0 .1.067.167.167.167H7.8c.1 0 .166-.067.166-.167v-.566h-.6ZM6.7 12.767v.566c0 .1.067.167.167.167h.266c.1 0 .167-.067.167-.167v-.566h-.6Z",
    fill: "#0071BC"
  })), portugal_path13 || (portugal_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M7 12.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM6.867 12.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.133 12.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.867 12.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.133 12.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7 11.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.867 11.7a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.133 11.7a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.867 11.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM7.133 11.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM7.667 12.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM7.533 12.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.8 12.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.533 12.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.8 12.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.333 12.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM6.2 12.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.467 12.533a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.2 12.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.467 12.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7 13.2a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM6.867 13.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM7.133 13.367a.067.067 0 1 0 0-.134.067.067 0 0 0 0 .134ZM6.867 13.033a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133ZM7.133 13.033a.067.067 0 1 0 0-.133.067.067 0 0 0 0 .133Z",
    fill: "#fff"
  })), portugal_path14 || (portugal_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M6.667 10.667h.666l-.066-.334V10h.066v-.167h-.1v.1H7.2v-.1h-.1v.1h-.067v-.1h-.066v.1H6.9v-.1h-.1v.1h-.067v-.1h-.066V10h.066v.333l-.066.334Z",
    fill: "#FFE62E"
  })), portugal_path15 || (portugal_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M7.1 10.667h-.033v-.134A.072.072 0 0 0 7 10.467a.072.072 0 0 0-.067.066v.134H6.9v-.134c0-.066.033-.1.1-.1s.1.034.1.1v.134ZM7 10.3h-.2v-.167c0-.066.033-.1.1-.1s.1.034.1.1v.167Zm-.167-.033h.134v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.067.066v.134ZM7.2 10.3H7v-.167c0-.066.033-.1.1-.1s.1.034.1.1v.167Zm-.167-.033h.134v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.067.066v.134Z",
    fill: "#3E4347"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M5 10.667h.667l-.067-.334V10h.067v-.167h-.1v.1h-.034v-.1h-.1v.1h-.066v-.1H5.3v.1h-.067v-.1h-.1v.1h-.066v-.1H5V10h.067v.333L5 10.667Z",
    fill: "#FFE62E"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M5.433 10.667H5.4v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.066.066v.134h-.034v-.134c0-.066.034-.1.1-.1.067 0 .1.034.1.1v.134ZM5.333 10.3h-.2v-.167c0-.066.034-.1.1-.1.067 0 .1.034.1.1v.167Zm-.166-.033H5.3v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.066.066v.134ZM5.533 10.3h-.2v-.167c0-.066.034-.1.1-.1.067 0 .1.034.1.1v.167Zm-.166-.033H5.5v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.066.066v.134Z",
    fill: "#3E4347"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M5 12.633h.667L5.6 12.3v-.333h.067V11.8H5.6v.1h-.067v-.1h-.066v.1h-.1v-.1H5.3v.1h-.067v-.1h-.066v.1H5.1v-.1H5v.167h.1v.333l-.1.333Z",
    fill: "#FFE62E"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M5.433 12.633H5.4V12.5a.072.072 0 0 0-.067-.067.072.072 0 0 0-.066.067v.133h-.034V12.5c0-.067.034-.1.1-.1.067 0 .1.033.1.1v.133ZM5.333 12.267h-.2V12.1c0-.067.034-.1.1-.1.067 0 .1.033.1.1v.167Zm-.166-.034H5.3V12.1a.072.072 0 0 0-.067-.067.072.072 0 0 0-.066.067v.133ZM5.567 12.267h-.2V12.1c0-.067.033-.1.1-.1.066 0 .1.033.1.1v.167Zm-.167-.034h.133V12.1a.072.072 0 0 0-.066-.067.072.072 0 0 0-.067.067v.133Z",
    fill: "#3E4347"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M8.333 12.667H9l-.067-.334V12H9v-.133h-.1v.066h-.033v-.066h-.1v.066H8.7v-.066h-.067v.066h-.066v-.066h-.1v.066H8.4v-.066h-.067V12H8.4v.333l-.067.334Z",
    fill: "#FFE62E"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M8.767 12.667h-.033v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.067.066v.134h-.033v-.134c0-.066.033-.1.1-.1s.1.034.1.1v.134ZM8.667 12.3h-.2v-.167c0-.066.033-.1.1-.1.066 0 .1.034.1.1v.167Zm-.167-.033h.133v-.134a.072.072 0 0 0-.066-.066.072.072 0 0 0-.067.066v.134ZM8.867 12.3h-.2v-.167c0-.066.033-.1.1-.1.066 0 .1.034.1.1v.167Zm-.167-.033h.133v-.134a.072.072 0 0 0-.066-.066.072.072 0 0 0-.067.066v.134Z",
    fill: "#3E4347"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M8.333 10.667H9l-.067-.334V10H9v-.167h-.1v.1h-.033v-.1h-.1v.1H8.7v-.1h-.067v.1h-.066v-.1h-.1v.1H8.4v-.1h-.067V10H8.4v.333l-.067.334Z",
    fill: "#FFE62E"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M8.767 10.667h-.033v-.134a.072.072 0 0 0-.067-.066.072.072 0 0 0-.067.066v.134h-.033v-.134c0-.066.033-.1.1-.1s.1.034.1.1v.134ZM8.667 10.3h-.2v-.167c0-.066.033-.1.1-.1.066 0 .1.034.1.1v.167Zm-.167-.033h.133v-.134a.072.072 0 0 0-.066-.066.072.072 0 0 0-.067.066v.134ZM8.867 10.3h-.2v-.167c0-.066.033-.1.1-.1.066 0 .1.034.1.1v.167Zm-.167-.033h.133v-.134a.072.072 0 0 0-.066-.066.072.072 0 0 0-.067.066v.134Z",
    fill: "#3E4347"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "m6.067 14.533.466-.5-.3-.166L6 13.633l.067-.066-.1-.1-.067.066.067.067-.034.033-.066-.066-.067.066.067.034-.067.066-.033-.066-.067.066.067.067-.067.033-.033-.066-.067.066.033.067-.033.033-.033-.066-.067.066.1.1h.033L5.667 14l.233.233.167.3Z",
    fill: "#FFE62E"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "m6.367 14.2-.134-.067c-.033-.033-.066-.033-.1 0-.033.034-.033.067 0 .1l.1.1-.033.034-.1-.1a.101.101 0 0 1 0-.134.101.101 0 0 1 .133 0l.134.067ZM6.033 14.033l-.133.134-.1-.1a.101.101 0 0 1 0-.134.101.101 0 0 1 .133 0l.1.1Zm-.133.1.1-.1-.1-.1c-.033-.033-.067-.033-.1 0-.033.034-.033.067 0 .1l.1.1ZM6.2 13.867 6.067 14l-.1-.1a.101.101 0 0 1 0-.133.101.101 0 0 1 .133 0l.1.1Zm-.133.1.1-.1-.1-.1c-.034-.034-.067-.034-.1 0-.034.033-.034.066 0 .1l.1.1Z",
    fill: "#3E4347"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "m7.933 14.533-.466-.5.266-.166.234-.234-.034-.066.1-.1.067.066-.067.067.034.033.066-.066.067.066-.067.034.067.066.033-.066.067.066-.067.067.067.033.033-.066.067.066-.067.067.067.033.033-.066.067.066-.1.1h-.033L8.333 14l-.233.233-.167.3Z",
    fill: "#FFE62E"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "m7.633 14.2.134-.067c.033-.033.066-.033.1 0 .033.034.033.067 0 .1l-.134.1.034.034.1-.1a.101.101 0 0 0 0-.134.101.101 0 0 0-.134 0l-.1.067ZM8.067 13.933a.101.101 0 0 1 .133 0c.033.034.033.1 0 .134l-.1.1-.133-.134.1-.1Zm.1.1c.033-.033.033-.066 0-.1-.034-.033-.067-.033-.1 0l-.067.1.1.1.067-.1ZM7.9 13.767a.101.101 0 0 1 .133 0c.034.033.034.1 0 .133l-.1.1-.133-.133.1-.1Zm.133.1c.034-.034.034-.067 0-.1-.033-.034-.066-.034-.1 0l-.1.1.1.1.1-.1Z",
    fill: "#3E4347"
  })));
};
/* harmony default export */ var portugal = (SvgPortugal);
;// CONCATENATED MODULE: ./src/svgs/flag/spain.svg
var spain_path, spain_path2, spain_path3, spain_path4, spain_path5, spain_path6, spain_path7, spain_path8, spain_path9, spain_path10, spain_path11, spain_path12, spain_path13, spain_path14, spain_path15, spain_path16, spain_path17, spain_path18, spain_path19, spain_path20, spain_path21, spain_path22, spain_path23, spain_path24, spain_path25, spain_path26, spain_path27, _path28, _path29, _path30;
function spain_extends() { spain_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return spain_extends.apply(this, arguments); }

var SvgSpain = function SvgSpain(props) {
  return /*#__PURE__*/react.createElement("svg", spain_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), spain_path || (spain_path = /*#__PURE__*/react.createElement("path", {
    d: "M2 12c0 1.967.567 3.8 1.533 5.333h16.9A9.98 9.98 0 0 0 21.967 12a9.98 9.98 0 0 0-1.534-5.333h-16.9A9.98 9.98 0 0 0 2 12Z",
    fill: "#FFCE31"
  })), spain_path2 || (spain_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M20.467 6.667A10.001 10.001 0 0 0 12 2a10 10 0 0 0-8.467 4.667h16.934ZM3.533 17.333A10 10 0 0 0 12 22c3.567 0 6.7-1.867 8.467-4.667H3.533Z",
    fill: "#ED4C5C"
  })), spain_path3 || (spain_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M4.4 10.9h1.067v.6H4.4v-.6ZM4.4 15.3h1.1v.567H4.4V15.3Z",
    fill: "#C8B100"
  })), spain_path4 || (spain_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M4.3 14.367c-.1.066-.167.133-.167.166 0 .034.034.067.1.1.067.034.134.1.1.167.067-.067.1-.133.1-.2 0-.1-.066-.2-.133-.233Z",
    fill: "#ED4C5C"
  })), spain_path5 || (spain_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M4.567 11.5h.766v3.8h-.766v-3.8Z",
    fill: "#fff"
  })), spain_path6 || (spain_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M6.133 12.9a2.326 2.326 0 0 0-.8-.133c-.1 0-.233 0-.366.033-.467.067-.834.267-.8.4L4 12.833c-.033-.166.367-.366.867-.466.166-.034.333-.034.466-.034.334 0 .634.034.8.1v.467Z",
    fill: "#ED4C5C"
  })), spain_path7 || (spain_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M4.567 13.4c-.2 0-.367-.067-.367-.167 0-.066.067-.166.2-.233h.2l-.033.4ZM5.333 13.1c.134.033.234.067.3.1.034.033-.1.167-.3.267V13.1Z",
    fill: "#ED4C5C"
  })), spain_path8 || (spain_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M4.067 14.133c-.034-.066.2-.2.5-.3.133-.033.233-.1.4-.166.4-.167.733-.4.666-.467l.067.4c.033.067-.233.267-.633.467a3.122 3.122 0 0 1-.5.2c-.234.066-.434.2-.434.233l-.066-.367Z",
    fill: "#ED4C5C"
  })), spain_path9 || (spain_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M11.567 10.9h1.067v.6h-1.067v-.6ZM11.533 15.3h1.1v.567h-1.1V15.3Z",
    fill: "#C8B100"
  })), spain_path10 || (spain_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M12.733 14.367c.1.066.167.133.167.166 0 .034-.033.067-.1.1-.067.067-.133.167-.1.2-.067-.066-.1-.133-.1-.2 0-.133.067-.233.133-.266Z",
    fill: "#ED4C5C"
  })), spain_path11 || (spain_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M11.7 11.5h.767v3.8H11.7v-3.8Z",
    fill: "#fff"
  })), spain_path12 || (spain_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M10.9 12.9c.167-.067.467-.133.8-.133.1 0 .233 0 .367.033.466.067.833.267.8.4l.166-.4c.034-.167-.366-.367-.866-.467H11.7c-.333 0-.633.034-.8.1v.467Z",
    fill: "#ED4C5C"
  })), spain_path13 || (spain_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M12.467 13.4c.2 0 .366-.067.366-.167 0-.066-.066-.166-.2-.233h-.2l.034.4ZM11.7 13.1a1.551 1.551 0 0 0-.3.1c-.033.033.1.167.3.267V13.1Z",
    fill: "#ED4C5C"
  })), spain_path14 || (spain_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M12.967 14.133c.033-.066-.2-.2-.5-.3-.134-.033-.234-.1-.4-.166-.4-.167-.734-.4-.667-.467l-.067.4c-.033.067.234.267.634.467.133.066.366.166.5.2.233.066.433.233.4.266l.1-.4ZM8.5 8.767c.633 0 1.933.133 2.4.6-.5 1.2-1.3.7-2.4.7-1.067 0-1.9.5-2.4-.7.467-.467 1.733-.6 2.4-.6Z",
    fill: "#ED4C5C"
  })), spain_path15 || (spain_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M10.133 10.1c-.4-.233-1-.267-1.633-.267s-1.233.067-1.633.267l.133.567c.367.1.9.166 1.5.166s1.1-.066 1.5-.166l.133-.567ZM10.7 8.667c-.133-.1-.4-.2-.633-.2-.1 0-.2 0-.3.033 0 0-.2-.267-.667-.267-.167 0-.3.034-.433.1V8.3c-.034-.067-.1-.133-.167-.133s-.167.1-.167.166v.034a.923.923 0 0 0-.433-.1c-.467 0-.667.3-.667.266-.1-.033-.2-.033-.3-.033-1.533 0-.766 1.033-.766 1.033l.166-.2c-.366-.466-.033-.733.634-.733.1 0 .166 0 .233.033-.233.334.2.634.2.634l.1-.167c-.233-.167-.267-.733.4-.733.167 0 .3.033.433.133 0 .033-.033.5-.066.567l.266.233.267-.233c-.033-.1-.067-.534-.067-.567a.834.834 0 0 1 .434-.133c.7 0 .7.566.4.733l.1.167s.366-.3.2-.634c.066 0 .166-.033.233-.033.8 0 .833.6.633.733l.134.2c-.067 0 .3-.466-.167-.866Z",
    fill: "#C8B100"
  })), spain_path16 || (spain_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M8.3 8.033c0-.1.1-.2.2-.2.133 0 .2.1.2.2s-.1.2-.2.2-.2-.1-.2-.2Z",
    fill: "#005BBF"
  })), spain_path17 || (spain_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M8.433 7.467v.1h-.1v.1h.1V8H8.3v.1h.4l.033-.067L8.7 8h-.134v-.333h.1v-.1h-.1v-.1h-.133Z",
    fill: "#C8B100"
  })), spain_path18 || (spain_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M8.5 10.767c-.533 0-1-.067-1.367-.167.367-.1.834-.167 1.367-.167s1 .067 1.367.167c-.334.1-.834.167-1.367.167Z",
    fill: "#ED4C5C"
  })), spain_path19 || (spain_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M8.533 16.533c-.633 0-1.233-.166-1.766-.4-.4-.2-.634-.566-.634-1v-1.6h4.8v1.6c0 .434-.266.834-.633 1-.533.267-1.133.4-1.767.4ZM8.5 10.867h2.4v2.666H8.5v-2.666Z",
    fill: "#fff"
  })), spain_path20 || (spain_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M8.533 15.133c0 .634-.533 1.134-1.2 1.134-.666 0-1.2-.5-1.2-1.134v-1.6h2.4v1.6Z",
    fill: "#ED4C5C"
  })), spain_path21 || (spain_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M6.634 16.067c.066.033.166.1.3.133v-2.733h-.267l-.033 2.6ZM6.1 15.1c0 .333.133.6.267.733v-2.366H6.1V15.1Z",
    fill: "#C8B100"
  })), spain_path22 || (spain_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M7.167 16.267h.266v-2.8h-.266v2.8Z",
    fill: "#C7B500"
  })), spain_path23 || (spain_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M7.7 16.2c.1-.033.234-.1.3-.133v-2.6h-.266L7.7 16.2Z",
    fill: "#C8B100"
  })), spain_path24 || (spain_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M6.1 10.867h2.4v2.666H6.1v-2.666Z",
    fill: "#ED4C5C"
  })), spain_path25 || (spain_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M8.267 15.833c.133-.1.233-.333.266-.6V13.5h-.266v2.333Z",
    fill: "#C8B100"
  })), spain_path26 || (spain_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M10.933 13.533v1.6c0 .634-.533 1.134-1.2 1.134-.666 0-1.2-.5-1.2-1.134v-1.6h2.4ZM10.066 11.333c.1.2.1.7-.2.6.067.034.1.267.2.4.167.2.367.034.334-.2-.067-.366-.034-.6.033-.966 0 .033.167.033.233-.034-.033.1-.066.234 0 .234-.066.1-.233.266-.266.366-.034.234.333.667-.067.767-.267.067-.1.267 0 .367 0 0-.133.433-.066.4-.267.1-.2-.134-.2-.134.133-.4-.234-.433-.2-.5-.334-.033.033.3-.267.3-.067 0-.2.067-.2.067-.367-.033-.167-.367-.034-.333.1.033.2.2.2-.034 0 0-.166-.266.267-.266-.167 0-.267-.134-.333-.3-.067.033-.167.2-.534.233 0 0-.1-.367 0-.3.134.067.2.067.334-.067-.067-.1-.467-.233-.4-.466 0-.067.2-.167.2-.167-.034.167.066.333.266.333.267.034.167-.066.2-.133.034-.067.234.033.167-.133 0-.034-.233-.067-.167-.167.134-.167.334-.033.5.133ZM8.533 16.2l-.066-.167.066-.2.067.2-.067.167Z",
    fill: "#ED4C5C"
  })), spain_path27 || (spain_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M6.833 11.433v.167H6.9v.133h-.167v.334h.1v.733h-.2v.367H8V12.8h-.167v-.733H7.9v-.334h-.167V11.6h.1v-.167H7.5v.167h.067v.133H7.4v-.4h.1v-.166h-.367v.166h.1v.4h-.166V11.6h.066v-.167h-.3ZM10.6 15.533v-1.666H8.866v1.666l.8.367h.1l.834-.367ZM9.666 14v.567L9.1 14h.566Zm-.7.033.667.667-.667.667v-1.334Zm.067 1.467.633-.633v.933l-.633-.3Zm.733.267v-.934l.634.634-.634.3Zm.7-.4L9.8 14.7l.666-.667v1.334ZM9.767 14h.567l-.567.567V14Z",
    fill: "#C8B100"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M7.733 13.5c0-.5.334-.867.767-.867s.767.4.767.867c0 .467-.334.867-.767.867S7.733 14 7.733 13.5Z",
    fill: "#ED4C5C"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M7.967 13.5c0-.367.233-.633.533-.633.3 0 .533.3.533.633 0 .367-.233.633-.533.633-.267.034-.533-.266-.533-.633Z",
    fill: "#005BBF"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "m8.267 13.067-.134.366.1.034-.066.133h.2l-.067-.133.1-.034-.133-.366ZM8.767 13.067l-.134.366.1.034-.066.133h.2l-.034-.133.1-.034-.166-.366ZM8.533 13.5l-.167.367.1.033-.033.133H8.6l-.034-.133.1-.033-.133-.367Z",
    fill: "#C8B100"
  })));
};
/* harmony default export */ var spain = (SvgSpain);
;// CONCATENATED MODULE: ./src/svgs/flag/thailand.svg
var thailand_path, thailand_path2, thailand_path3;
function thailand_extends() { thailand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return thailand_extends.apply(this, arguments); }

var SvgThailand = function SvgThailand(props) {
  return /*#__PURE__*/react.createElement("svg", thailand_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), thailand_path || (thailand_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.8 4.667A9.928 9.928 0 0 0 12 2C9.367 2 7 3 5.2 4.667h13.6ZM5.2 19.333A9.928 9.928 0 0 0 12 22c2.633 0 5-1 6.8-2.667H5.2Z",
    fill: "#ED4C5C"
  })), thailand_path2 || (thailand_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2 12c0 1.433.3 2.767.833 4h18.334A9.99 9.99 0 0 0 22 12a9.99 9.99 0 0 0-.833-4H2.833A9.989 9.989 0 0 0 2 12Z",
    fill: "#2A5F9E"
  })), thailand_path3 || (thailand_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M5.2 19.334h13.567c1-.934 1.833-2.067 2.366-3.334H2.8c.6 1.267 1.4 2.4 2.4 3.334ZM18.8 4.667H5.2C4.2 5.6 3.367 6.733 2.833 8h18.334A10.298 10.298 0 0 0 18.8 4.667Z",
    fill: "#F9F9F9"
  })));
};
/* harmony default export */ var thailand = (SvgThailand);
;// CONCATENATED MODULE: ./src/svgs/flag/turkey.svg
var turkey_path, turkey_path2, turkey_path3;
function turkey_extends() { turkey_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return turkey_extends.apply(this, arguments); }

var SvgTurkey = function SvgTurkey(props) {
  return /*#__PURE__*/react.createElement("svg", turkey_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), turkey_path || (turkey_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#ED4C5C"
  })), turkey_path2 || (turkey_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m15.1 14.333.033-1.8-1.8-.533 1.8-.533-.033-1.8 1.1 1.433 1.8-.533L16.9 12l1.1 1.433-1.8-.533-1.1 1.433Z",
    fill: "#fff"
  })), turkey_path3 || (turkey_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M12.4 16c-2.2 0-3.967-1.8-3.967-4S10.2 8 12.4 8c.833 0 1.6.267 2.267.7A4.938 4.938 0 0 0 10.933 7C8.2 7 6 9.233 6 12s2.2 5 4.933 5c1.5 0 2.834-.667 3.734-1.7-.634.433-1.4.7-2.267.7Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var turkey = (SvgTurkey);
;// CONCATENATED MODULE: ./src/svgs/flag/vietnamese.svg
var vietnamese_path, vietnamese_path2;
function vietnamese_extends() { vietnamese_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vietnamese_extends.apply(this, arguments); }

var SvgVietnamese = function SvgVietnamese(props) {
  return /*#__PURE__*/react.createElement("svg", vietnamese_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), vietnamese_path || (vietnamese_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#F42F4C"
  })), vietnamese_path2 || (vietnamese_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m12 14.333 3.3 2.334-1.233-3.8 3.266-2.467h-4.066L12 6.667 10.767 10.4h-4.1l3.266 2.467-1.233 3.8 3.3-2.334Z",
    fill: "#FFE62E"
  })));
};
/* harmony default export */ var vietnamese = (SvgVietnamese);
;// CONCATENATED MODULE: ./src/svgs/flag/japan.svg
function japan_extends() { japan_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return japan_extends.apply(this, arguments); }

var SvgJapan = function SvgJapan(props) {
  return /*#__PURE__*/react.createElement("svg", japan_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20
  }, props), /*#__PURE__*/react.createElement("circle", {
    style: {
      fill: "#f0f0f0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/react.createElement("circle", {
    style: {
      fill: "#d80027"
    },
    cx: 256,
    cy: 256,
    r: 111.304
  }));
};
/* harmony default export */ var japan = (SvgJapan);
;// CONCATENATED MODULE: ./src/svgs/casino.svg
var casino_path, casino_path2, casino_path3;
function casino_extends() { casino_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return casino_extends.apply(this, arguments); }

var SvgCasino = function SvgCasino(props) {
  return /*#__PURE__*/react.createElement("svg", casino_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), casino_path || (casino_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 8.625 9.623 11.13a1.402 1.402 0 0 0 0 1.89 1.223 1.223 0 0 0 1.755 0 .566.566 0 0 1 .112-.098.33.33 0 0 1 .322 0 .262.262 0 0 1 .143.255 4.785 4.785 0 0 1-.863 2.318h1.816a4.785 4.785 0 0 1-.863-2.317.263.263 0 0 1 .135-.27.3.3 0 0 1 .315 0c.048.028.09.063.128.104a1.223 1.223 0 0 0 1.755 0 1.395 1.395 0 0 0 0-1.89L12 8.626Z",
    fill: "#fff"
  })), casino_path2 || (casino_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 4.905A7.095 7.095 0 1 0 19.087 12 7.11 7.11 0 0 0 12 4.905Zm2.783 8.505a1.772 1.772 0 0 1-2.048.383c.166.67.502 1.288.975 1.792a.285.285 0 0 1 .052.307.278.278 0 0 1-.255.173H10.5a.278.278 0 0 1-.255-.173.285.285 0 0 1 .053-.307 3.99 3.99 0 0 0 .952-1.793 1.8 1.8 0 0 1-2.048-.382 1.958 1.958 0 0 1 0-2.662l2.58-2.723a.27.27 0 0 1 .405 0l2.58 2.723a1.958 1.958 0 0 1 .016 2.662Z",
    fill: "#fff"
  })), casino_path3 || (casino_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m20.715 5.498-.315-.39-.33-.383a5.524 5.524 0 0 0-.413-.427 6.572 6.572 0 0 0-.48-.443l-.12-.105c-.172-.15-.36-.292-.547-.435a10.732 10.732 0 0 0-4.965-2.062 10.665 10.665 0 0 0-3.09 0 10.755 10.755 0 0 0-4.958 2.032c-.142.12-.3.233-.435.353l-.277.24c-.317.275-.615.57-.893.885l-.24.277c-.12.135-.232.293-.352.435a10.867 10.867 0 0 0 0 13.005c.12.142.232.3.352.435l.24.277c.271.309.562.6.87.87l.278.24c.135.12.292.233.435.353a10.756 10.756 0 0 0 4.957 2.047c.27 0 .525.068.75.083.225.015.51 0 .75 0h.75c.233 0 .51-.045.75-.082a10.732 10.732 0 0 0 4.965-2.063c.188-.143.375-.285.548-.435l.105-.097c.165-.136.322-.285.48-.443.145-.135.283-.278.412-.427l.33-.383.315-.39a10.867 10.867 0 0 0 0-13.005l.128.038ZM12 20.602A8.602 8.602 0 1 1 20.602 12 8.617 8.617 0 0 1 12 20.602ZM12 2.64a1.215 1.215 0 0 1-1.17-.877c.777-.09 1.563-.09 2.34 0A1.215 1.215 0 0 1 12 2.64Zm8.07 2.948a1.222 1.222 0 0 1-1.455-.21 1.2 1.2 0 0 1-.21-1.448 10.544 10.544 0 0 1 1.665 1.658ZM5.587 3.93A1.222 1.222 0 0 1 3.93 5.588c.49-.611 1.047-1.167 1.657-1.658ZM3.93 18.413a1.222 1.222 0 0 1 1.657 1.657 11.17 11.17 0 0 1-1.657-1.657Zm6.9 3.825a1.215 1.215 0 0 1 2.34 0c-.778.082-1.562.082-2.34 0Zm7.575-2.168a1.2 1.2 0 0 1 .21-1.448 1.223 1.223 0 0 1 .885-.36c.207-.003.412.05.592.15a10.537 10.537 0 0 1-1.687 1.658Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var casino = (SvgCasino);
;// CONCATENATED MODULE: ./src/svgs/sport.svg
var sport_path, sport_path2, sport_path3, sport_path4;
function sport_extends() { sport_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sport_extends.apply(this, arguments); }

var SvgSport = function SvgSport(props) {
  return /*#__PURE__*/react.createElement("svg", sport_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), sport_path || (sport_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.05 17.195a9.411 9.411 0 0 1-1.545-4.94A27.564 27.564 0 0 1 7.9 10.8a9.503 9.503 0 0 1-3.85 6.395Zm3.935-7.43A27.9 27.9 0 0 0 2.54 11.18 9.456 9.456 0 0 1 6.445 4.3 9.454 9.454 0 0 1 8 9.5c0 .09-.01.175-.015.265ZM7.28 3.76a9.399 9.399 0 0 1 4.22-1.25v6.95c-.84.02-1.68.075-2.505.17 0-.045.005-.085.005-.13a10.41 10.41 0 0 0-1.72-5.74Z",
    fill: "#ADADAD"
  })), sport_path2 || (sport_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8.935 10.645a25.704 25.704 0 0 1 2.565-.185v11.03A9.498 9.498 0 0 1 4.635 18a10.476 10.476 0 0 0 4.3-7.355Zm6.07-1.035c-.845-.09-1.685-.14-2.505-.155V2.51a9.399 9.399 0 0 1 4.22 1.25A10.41 10.41 0 0 0 15 9.5c0 .035.005.07.005.11Zm4.36 8.385A9.474 9.474 0 0 1 12.5 21.49V10.455c.856.01 1.71.066 2.56.165a10.462 10.462 0 0 0 4.305 7.375ZM16 9.5a9.454 9.454 0 0 1 1.555-5.2 9.464 9.464 0 0 1 3.895 6.735 30.966 30.966 0 0 0-5.44-1.295c0-.08-.01-.16-.01-.24Z",
    fill: "#ADADAD"
  })), sport_path3 || (sport_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M21.5 12.1a9.414 9.414 0 0 1-1.55 5.095 9.488 9.488 0 0 1-3.855-6.43c1.839.279 3.648.726 5.405 1.335Z",
    fill: "#ADADAD"
  })), sport_path4 || (sport_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M7.28 3.76A10.41 10.41 0 0 1 9 9.5c0 .045-.005.085-.005.13a27.72 27.72 0 0 1 2.505-.17V2.51a9.399 9.399 0 0 0-4.22 1.25Zm-.835.54a9.457 9.457 0 0 0-3.905 6.88 27.9 27.9 0 0 1 5.445-1.415C7.99 9.675 8 9.59 8 9.5a9.454 9.454 0 0 0-1.555-5.2Zm-3.94 7.955a9.411 9.411 0 0 0 1.545 4.94A9.503 9.503 0 0 0 7.9 10.8c-1.843.301-3.65.788-5.395 1.455ZM16.72 3.76a9.399 9.399 0 0 0-4.22-1.25v6.945c.82.015 1.66.065 2.505.155 0-.04-.005-.075-.005-.11a10.41 10.41 0 0 1 1.72-5.74Zm-1.66 6.86c-.85-.1-1.705-.154-2.56-.165V21.49a9.476 9.476 0 0 0 6.865-3.495 10.462 10.462 0 0 1-4.305-7.375Zm-6.125.025A10.477 10.477 0 0 1 4.635 18a9.497 9.497 0 0 0 6.865 3.49V10.46c-.858.019-1.714.08-2.565.185Zm8.62-6.345A9.453 9.453 0 0 0 16 9.5c0 .08.01.16.01.24 1.849.267 3.67.7 5.44 1.295A9.464 9.464 0 0 0 17.555 4.3Zm-1.46 6.465a9.488 9.488 0 0 0 3.855 6.43A9.414 9.414 0 0 0 21.5 12.1a30.451 30.451 0 0 0-5.405-1.335Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var sport = (SvgSport);
;// CONCATENATED MODULE: ./src/svgs/all-game-icon.svg
var all_game_icon_path;
function all_game_icon_extends() { all_game_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return all_game_icon_extends.apply(this, arguments); }

var SvgAllGameIcon = function SvgAllGameIcon(props) {
  return /*#__PURE__*/react.createElement("svg", all_game_icon_extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), all_game_icon_path || (all_game_icon_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.164 4.083.948.011c3.405 0 5.888 2.428 5.888 5.78v4.307c0 3.353-2.483 5.78-5.888 5.78A193.5 193.5 0 0 1 10.01 20c-1.374 0-2.758-.01-4.122-.038-3.405 0-5.888-2.428-5.888-5.78V9.874c0-3.353 2.483-5.78 5.898-5.78 1.286-.02 2.6-.04 3.935-.04v-.163c0-.665-.56-1.204-1.227-1.204h-.971c-1.109 0-2.012-.886-2.012-1.965 0-.395.334-.723.736-.723.412 0 .736.328.736.723 0 .289.246.52.54.52h.971c1.482.01 2.69 1.194 2.7 2.64v.183c.618 0 1.237.008 1.858.017Zm-4.312 8.663h-1.03v1.02a.735.735 0 0 1-.736.723.728.728 0 0 1-.737-.722v-1.021H5.31a.728.728 0 0 1-.736-.723c0-.395.334-.722.736-.722h1.04v-1.012c0-.395.324-.723.737-.723.402 0 .736.328.736.723v1.012h1.03c.402 0 .736.327.736.722a.728.728 0 0 1-.736.723Zm4.171-1.628h.098a.729.729 0 0 0 .736-.723.735.735 0 0 0-.736-.723h-.098a.722.722 0 1 0 0 1.445Zm1.678 3.314h.098a.728.728 0 0 0 .736-.723.735.735 0 0 0-.736-.722h-.098a.722.722 0 1 0 0 1.445Z"
  })));
};
/* harmony default export */ var all_game_icon = (SvgAllGameIcon);
;// CONCATENATED MODULE: ./src/svgs/success-status.svg
var _circle, success_status_path;
function success_status_extends() { success_status_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return success_status_extends.apply(this, arguments); }

var SvgSuccessStatus = function SvgSuccessStatus(props) {
  return /*#__PURE__*/react.createElement("svg", success_status_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.2 130.2"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    fill: "none",
    stroke: "#06c270",
    cx: 65.1,
    cy: 65.1,
    r: 62.1
  })), success_status_path || (success_status_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    stroke: "#06c270",
    d: "M100.2 40.2 51.5 88.8 29.8 67.5"
  })));
};
/* harmony default export */ var success_status = (SvgSuccessStatus);
;// CONCATENATED MODULE: ./src/svgs/menu.svg
var menu_path;
function menu_extends() { menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "data-testid": "MenuOpenRoundedIcon"
  }, props), menu_path || (menu_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 18h11c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h8c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm17.3 7.88L17.42 12l2.88-2.88a.996.996 0 0 0 0-1.41.996.996 0 0 0-1.41 0L15.3 11.3a.996.996 0 0 0 0 1.41l3.59 3.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
  })));
};
/* harmony default export */ var menu = (SvgMenu);
;// CONCATENATED MODULE: ./src/svgs/menu-bar.svg
var menu_bar_path;
function menu_bar_extends() { menu_bar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_bar_extends.apply(this, arguments); }

var SvgMenuBar = function SvgMenuBar(props) {
  return /*#__PURE__*/react.createElement("svg", menu_bar_extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), menu_bar_path || (menu_bar_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.334 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2h-16a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2h-16a1 1 0 0 1-1-1Zm1 5a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2h-16Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var menu_bar = (SvgMenuBar);
;// CONCATENATED MODULE: ./src/svgs/user-icon.svg
var user_icon_path;
function user_icon_extends() { user_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_icon_extends.apply(this, arguments); }

var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/react.createElement("svg", user_icon_extends({
    className: "user-icon_svg__MuiSvgIcon-root",
    viewBox: "0 0 24 24"
  }, props), user_icon_path || (user_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
  })));
};
/* harmony default export */ var user_icon = (SvgUserIcon);
;// CONCATENATED MODULE: ./src/svgs/user-icon-outlined.svg
var user_icon_outlined_path;
function user_icon_outlined_extends() { user_icon_outlined_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_icon_outlined_extends.apply(this, arguments); }

var SvgUserIconOutlined = function SvgUserIconOutlined(props) {
  return /*#__PURE__*/react.createElement("svg", user_icon_outlined_extends({
    className: "user-icon-outlined_svg__user-icon",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, props), user_icon_outlined_path || (user_icon_outlined_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
  })));
};
/* harmony default export */ var user_icon_outlined = (SvgUserIconOutlined);
;// CONCATENATED MODULE: ./src/svgs/block-icon.svg
var block_icon_path;
function block_icon_extends() { block_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return block_icon_extends.apply(this, arguments); }

var SvgBlockIcon = function SvgBlockIcon(props) {
  return /*#__PURE__*/react.createElement("svg", block_icon_extends({
    className: "block-icon_svg__block-icon",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, props), block_icon_path || (block_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 0 1 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0 1 20 12c0 4.42-3.58 8-8 8z"
  })));
};
/* harmony default export */ var block_icon = (SvgBlockIcon);
;// CONCATENATED MODULE: ./src/svgs/hunnypoker.svg
var hunnypoker_path, hunnypoker_path2, hunnypoker_path3, hunnypoker_path4;
function hunnypoker_extends() { hunnypoker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hunnypoker_extends.apply(this, arguments); }

var SvgHunnypoker = function SvgHunnypoker(props) {
  return /*#__PURE__*/react.createElement("svg", hunnypoker_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    }
  }, props), hunnypoker_path || (hunnypoker_path = /*#__PURE__*/react.createElement("path", {
    clipRule: "evenodd",
    d: "M7 2h15v20H7V2Z",
    stroke: "#A8A9AC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), hunnypoker_path2 || (hunnypoker_path2 = /*#__PURE__*/react.createElement("path", {
    clipRule: "evenodd",
    d: "M3 5.895 7 5v17L3 5.895Z",
    stroke: "#A8A9AC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hunnypoker_path3 || (hunnypoker_path3 = /*#__PURE__*/react.createElement("path", {
    clipRule: "evenodd",
    d: "M14.5 9 12 12l2.5 3 2.5-3-2.5-3Z",
    stroke: "#A8A9AC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), hunnypoker_path4 || (hunnypoker_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M10 5v2M19 17v2",
    stroke: "#A8A9AC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var hunnypoker = (SvgHunnypoker);
;// CONCATENATED MODULE: ./src/svgs/transaction-history.svg
var transaction_history_path, transaction_history_path2;
function transaction_history_extends() { transaction_history_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return transaction_history_extends.apply(this, arguments); }

var SvgTransactionHistory = function SvgTransactionHistory(props) {
  return /*#__PURE__*/react.createElement("svg", transaction_history_extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), transaction_history_path || (transaction_history_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 15c-.94 0-1.81.33-2.5.88A3.97 3.97 0 0 0 1 19c0 2.21 1.79 4 4 4a4 4 0 0 0 2.64-1C8.47 21.27 9 20.2 9 19c0-2.21-1.79-4-4-4Zm1 4.25c0 .26-.14.51-.36.64l-1.25.75c-.12.08-.26.11-.39.11-.25 0-.5-.13-.64-.36-.21-.36-.1-.82.26-1.03l.89-.53v-1.08a.74.74 0 0 1 .74-.75c.41 0 .75.34.75.75v1.5ZM14.85 3.95v3.8h-1.5v-3.8c0-.27-.24-.4-.4-.4-.05 0-.1.01-.15.03L4.87 6.57c-.53.2-.87.7-.87 1.27v.67c-.91.68-1.5 1.77-1.5 3V7.84c0-1.19.73-2.25 1.84-2.67l7.94-3c.22-.08.45-.12.67-.12 1 0 1.9.81 1.9 1.9ZM21.5 14.5v1a.5.5 0 0 1-.49.5h-1.46c-.53 0-1.01-.39-1.05-.91-.03-.31.09-.6.29-.8a.95.95 0 0 1 .7-.29H21c.29.01.5.23.5.5Z"
  })), transaction_history_path2 || (transaction_history_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.48 12.95h1.02c.55 0 1-.45 1-1v-.44c0-2.07-1.69-3.76-3.76-3.76H6.26c-.85 0-1.63.28-2.26.76-.91.68-1.5 1.77-1.5 3v1.78c0 .38.4.62.76.5.56-.19 1.15-.29 1.74-.29 3.03 0 5.5 2.47 5.5 5.5 0 .72-.19 1.51-.49 2.21-.16.36.09.79.48.79h7.25c2.07 0 3.76-1.69 3.76-3.76v-.19c0-.55-.45-1-1-1h-.87c-.96 0-1.88-.59-2.13-1.52-.2-.76.04-1.5.54-1.98.37-.38.88-.6 1.44-.6Zm-5.48-.2H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75Z"
  })));
};
/* harmony default export */ var transaction_history = (SvgTransactionHistory);
;// CONCATENATED MODULE: ./src/svgs/farm.svg
var farm_path, farm_path2;
function farm_extends() { farm_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return farm_extends.apply(this, arguments); }

var SvgFarm = function SvgFarm(props) {
  return /*#__PURE__*/react.createElement("svg", farm_extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), farm_path || (farm_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.73 13.694c.93 0 1.78.28 2.5.76v-4.76c0-1.1-.9-2-2-2h-6.29l-1.06-1.06 1.06-1.06c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-2.83 2.83c-.2.2-.2.51 0 .71.2.2.51.2.71 0l1.06-1.06 1.06 1.06v2.29c0 1.1-.9 2-2 2h-.54a5.98 5.98 0 0 1 1.54 4c0 .34-.04.67-.09 1h3.14c.25-2.24 2.14-4 4.45-4Z"
  })), farm_path2 || (farm_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.73 14.694c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5Zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5ZM4.23 10.694h5c0-1.1-.9-2-2-2h-3c-.55 0-1 .45-1 1 0 .56.45 1 1 1ZM10.06 15.514l-.18-.47.93-.35a4.92 4.92 0 0 0-2.31-2.43l-.4.89-.46-.21.4-.9c-.55-.21-1.17-.35-1.81-.35-.53 0-1.04.11-1.52.26l.34.91-.47.18-.35-.92a4.92 4.92 0 0 0-2.43 2.31l.89.4-.21.46-.9-.4a4.85 4.85 0 0 0-.35 1.8c0 .53.11 1.04.26 1.52l.91-.34.18.47-.93.35a4.92 4.92 0 0 0 2.31 2.43l.4-.89.46.21-.4.9c.57.22 1.18.35 1.82.35.53 0 1.04-.11 1.52-.26l-.35-.91.47-.18.35.93a4.92 4.92 0 0 0 2.43-2.31l-.89-.4.21-.46.9.4c.22-.57.35-1.18.35-1.82 0-.53-.11-1.04-.26-1.52l-.91.35Zm-2.68 3.96c-1.53.63-3.29-.09-3.92-1.62-.63-1.53.09-3.29 1.62-3.92 1.53-.63 3.29.09 3.92 1.62.64 1.53-.09 3.28-1.62 3.92Z"
  })));
};
/* harmony default export */ var farm = (SvgFarm);
;// CONCATENATED MODULE: ./src/svgs/hunnyswap.svg
var hunnyswap_path, hunnyswap_path2, hunnyswap_path3, hunnyswap_path4;
function hunnyswap_extends() { hunnyswap_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hunnyswap_extends.apply(this, arguments); }

var SvgHunnyswap = function SvgHunnyswap(props) {
  return /*#__PURE__*/react.createElement("svg", hunnyswap_extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hunnyswap_path || (hunnyswap_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.852 16.704a.557.557 0 0 0 .313-.204.598.598 0 0 0 .104-.358.656.656 0 0 0-.1-.367.498.498 0 0 0-.276-.208 2.495 2.495 0 0 0-.648-.059h-.86v1.246h.906c.188.007.377-.01.561-.05Z"
  })), hunnyswap_path2 || (hunnyswap_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.042 11.256a5.886 5.886 0 1 0 5.886 5.887 5.919 5.919 0 0 0-5.886-5.887Zm2.015 7.458a1.182 1.182 0 0 1-.344.453 1.526 1.526 0 0 1-.512.231c-.149.034-.3.054-.453.059v.616h-.593v-.612h-.317v.598h-.593v-.598h-.557V14.87h.557v-.598h.593v.598h.317v-.598h.588v.625c.179.012.354.05.521.113.214.095.392.253.512.453.119.185.183.4.186.62 0 .202-.056.4-.163.57-.097.154-.229.281-.385.372a1.132 1.132 0 0 1 .765 1.096c.004.205-.037.407-.122.593Z"
  })), hunnyswap_path3 || (hunnyswap_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M8.006 17.469a2.088 2.088 0 0 0-.638-.072h-.983v1.43h1.064a2.52 2.52 0 0 0 .394-.022.908.908 0 0 0 .322-.113.548.548 0 0 0 .208-.231.72.72 0 0 0 .081-.349.73.73 0 0 0-.117-.407.64.64 0 0 0-.33-.236Zm9.677-7.64a3.822 3.822 0 0 0-.398-.121v1.512c.14-.01.28-.041.412-.09a.865.865 0 0 0 .398-.281.666.666 0 0 0 .127-.385.589.589 0 0 0-.122-.367.933.933 0 0 0-.417-.267Zm-1.798-1.688a.507.507 0 0 0 .173.39c.177.113.373.194.58.24V7.506a1.01 1.01 0 0 0-.504.18.585.585 0 0 0-.249.454Z"
  })), hunnyswap_path4 || (hunnyswap_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M16.959 3.431a5.887 5.887 0 1 0 5.886 5.887 5.914 5.914 0 0 0-5.886-5.887Zm1.756 7.721c-.158.247-.387.44-.656.557a2.187 2.187 0 0 1-.774.177v.697h-.648v-.702a2.266 2.266 0 0 1-.666-.158 1.621 1.621 0 0 1-.724-.594 1.703 1.703 0 0 1-.277-.905v-.05l.711-.063v.054c.019.203.085.399.195.57a1 1 0 0 0 .453.358c.094.043.193.075.294.095V9.544a3.768 3.768 0 0 1-.76-.258 1.386 1.386 0 0 1-.54-.452 1.187 1.187 0 0 1-.18-.634c.008-.265.097-.52.253-.734.156-.23.379-.407.639-.507.2-.08.41-.129.625-.145v-.707h.647v.711c.21.021.416.072.612.15.264.11.49.298.647.539.152.237.236.51.245.792v.055l-.725.054v-.054a.928.928 0 0 0-.317-.657.996.996 0 0 0-.453-.2v1.44c.274.062.542.145.802.25.261.105.487.283.652.511.14.215.213.468.208.725-.011.27-.103.53-.263.747v-.018Zm-8.413-8.676a.453.453 0 1 0-.611.665l.724.657c-1.87 0-3.35.516-4.406 1.567-1.934 1.888-1.716 4.755-1.707 4.859a.453.453 0 0 0 .453.416h.036a.455.455 0 0 0 .417-.489c0-.022-.173-2.58 1.43-4.17.87-.86 2.12-1.29 3.714-1.29l-.906.778a.453.453 0 0 0-.023.68.453.453 0 0 0 .639.04l1.811-1.576a.453.453 0 0 0 .01-.675l-1.581-1.462ZM21.35 15.504a.453.453 0 0 0-.453.425c0 .027-.158 2.572-1.96 3.944-.979.743-2.265 1.006-3.859.797l.983-.656a.454.454 0 1 0-.525-.734l-1.988 1.327a.455.455 0 0 0-.095.67l1.358 1.63a.453.453 0 0 0 .634.06.452.452 0 0 0 .059-.64l-.616-.783c.388.059.78.09 1.173.091a5.474 5.474 0 0 0 3.41-1.042c2.133-1.625 2.31-4.491 2.318-4.614a.453.453 0 0 0-.44-.475Z"
  })));
};
/* harmony default export */ var hunnyswap = (SvgHunnyswap);
;// CONCATENATED MODULE: ./src/svgs/expand.svg
var expand_path;
function expand_extends() { expand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expand_extends.apply(this, arguments); }

var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/react.createElement("svg", expand_extends({
    width: 20,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), expand_path || (expand_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.775 13.214c0-.158.058-.316.183-.441l5.434-5.434a2.283 2.283 0 0 1 3.216 0l5.434 5.434a.629.629 0 0 1 0 .883.629.629 0 0 1-.884 0l-5.433-5.433c-.4-.4-1.05-.4-1.45 0l-5.433 5.433a.629.629 0 0 1-.884 0 .655.655 0 0 1-.183-.442Z"
  })));
};
/* harmony default export */ var expand = (SvgExpand);
;// CONCATENATED MODULE: ./src/svgs/stake.svg
var stake_path;
function stake_extends() { stake_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stake_extends.apply(this, arguments); }

var SvgStake = function SvgStake(props) {
  return /*#__PURE__*/react.createElement("svg", stake_extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), stake_path || (stake_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.75 3c-1.345 0-2.563.252-3.516.727C11.282 4.202 10.5 4.975 10.5 6v3c0 .097.032.19.047.281A9.134 9.134 0 0 0 8.25 9c-1.345 0-2.564.252-3.516.727C3.782 10.2 3 10.975 3 12v6c0 1.025.782 1.799 1.735 2.273.951.475 2.17.727 3.515.727 1.345 0 2.563-.252 3.516-.727C12.717 19.8 13.5 19.025 13.5 18v-.305c.734.199 1.49.301 2.25.305 1.345 0 2.564-.252 3.516-.727C20.217 16.8 21 16.025 21 15V6c0-1.025-.782-1.798-1.735-2.273-.95-.475-2.17-.727-3.515-.727Zm0 1.5c1.142 0 2.16.246 2.836.586.677.34.914.697.914.914 0 .218-.237.574-.914.914-.676.34-1.694.586-2.836.586s-2.16-.246-2.836-.586C12.237 6.574 12 6.217 12 6c0-.218.237-.574.914-.914.676-.34 1.694-.586 2.836-.586ZM12 8.133c.079.044.152.1.235.14.952.475 2.17.727 3.515.727 1.345 0 2.564-.252 3.516-.727.082-.04.155-.096.234-.14V9c0 .217-.237.575-.914.914-.677.34-1.694.586-2.836.586s-2.16-.246-2.836-.586C12.237 9.574 12 9.217 12 9v-.867ZM8.25 10.5c1.142 0 2.16.246 2.836.586.677.34.914.697.914.914 0 .217-.237.575-.914.914-.677.34-1.694.586-2.836.586s-2.16-.246-2.836-.586c-.677-.34-.914-.697-.914-.914 0-.217.237-.575.914-.914.676-.34 1.694-.586 2.836-.586Zm11.25.633V12c0 .217-.237.575-.914.914-.677.34-1.694.586-2.836.586a7.127 7.127 0 0 1-2.25-.352V12c0-.097-.032-.19-.047-.281.697.181 1.47.281 2.297.281 1.345 0 2.564-.252 3.516-.727.082-.04.155-.096.234-.14Zm-15 3c.079.044.152.1.235.14.951.475 2.17.727 3.515.727 1.345 0 2.563-.252 3.516-.727.082-.04.155-.096.234-.14V15c0 .217-.237.575-.914.914-.677.34-1.694.586-2.836.586s-2.16-.246-2.836-.586c-.677-.34-.914-.697-.914-.914v-.867Zm15 0V15c0 .217-.237.575-.914.914-.677.34-1.694.586-2.836.586-.853 0-1.623-.12-2.25-.328v-1.453a8.8 8.8 0 0 0 2.25.281c1.345 0 2.564-.252 3.516-.727.082-.04.155-.096.234-.14Zm-15 3c.079.044.152.1.235.14.951.475 2.17.727 3.515.727 1.345 0 2.563-.252 3.516-.727.082-.04.155-.096.234-.14V18c0 .218-.237.575-.914.914-.677.34-1.694.586-2.836.586s-2.16-.246-2.836-.586c-.677-.34-.914-.697-.914-.914v-.867Z"
  })));
};
/* harmony default export */ var stake = (SvgStake);
;// CONCATENATED MODULE: ./src/svgs/news.svg
var news_path, news_path2;
function news_extends() { news_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return news_extends.apply(this, arguments); }

var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/react.createElement("svg", news_extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), news_path || (news_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.8 2.924c-.41-.41-1.12-.13-1.12.44v3.49c0 1.46 1.24 2.67 2.75 2.67.95.01 2.27.01 3.4.01.57 0 .87-.67.47-1.07-1.44-1.45-4.02-4.06-5.5-5.54Z"
  })), news_path2 || (news_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M20.5 10.904h-2.89c-2.37 0-4.3-1.93-4.3-4.3v-2.89c0-.55-.45-1-1-1H8.07c-3.08 0-5.57 2-5.57 5.57v8.86c0 3.57 2.49 5.57 5.57 5.57h7.86c3.08 0 5.57-2 5.57-5.57v-5.24c0-.55-.45-1-1-1Zm-9 7.56h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75Zm2-4h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75Z"
  })));
};
/* harmony default export */ var news = (SvgNews);
;// CONCATENATED MODULE: ./src/svgs/new.svg
var _g, _defs;
function new_extends() { new_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return new_extends.apply(this, arguments); }

var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/react.createElement("svg", new_extends({
    width: 38,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#new_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 3.164A3 3 0 0 1 3.16.17L33.07 1.764c2.12.113 3.456 2.333 2.561 4.259L31.697 14.5a3 3 0 0 1-2.337 1.712L3.384 19.563A3 3 0 0 1 0 16.588V3.164Z",
    fill: "url(#new_svg__b)"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M4.913 13V5.3h1.474l4.543 5.544h-.715V5.3h1.76V13h-1.463L5.958 7.456h.715V13h-1.76Zm11.48.088c-.675 0-1.269-.132-1.782-.396a2.941 2.941 0 0 1-1.177-1.078 2.985 2.985 0 0 1-.418-1.573c0-.594.136-1.118.407-1.573a2.912 2.912 0 0 1 1.133-1.078 3.281 3.281 0 0 1 1.617-.396c.58 0 1.1.125 1.562.374.47.242.84.594 1.11 1.056.272.455.408 1.001.408 1.639 0 .066-.004.143-.011.231l-.022.231h-4.807V9.524h3.905l-.66.297c0-.308-.063-.576-.187-.803a1.327 1.327 0 0 0-.517-.528 1.468 1.468 0 0 0-.77-.198c-.294 0-.554.066-.781.198a1.31 1.31 0 0 0-.517.539 1.669 1.669 0 0 0-.187.814v.264c0 .323.07.609.209.858.147.242.348.429.605.561.264.125.572.187.924.187.315 0 .59-.048.825-.143.242-.095.462-.238.66-.429l.913.99a2.711 2.711 0 0 1-1.023.715c-.41.161-.884.242-1.42.242ZM21.42 13l-2.134-5.918h1.617l1.77 5.093h-.77l1.849-5.093h1.452l1.793 5.093h-.77l1.826-5.093h1.518L27.427 13h-1.661l-1.573-4.367h.506L23.07 13h-1.65Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "new_svg__b",
    x1: 41.5,
    y1: -6,
    x2: -8,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F953C6"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#B91D73",
    stopOpacity: 0
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "new_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h37.5v20H0z"
  })))));
};
/* harmony default export */ var svgs_new = (SvgNew);
;// CONCATENATED MODULE: ./src/svgs/new-secondary.svg
var new_secondary_path, new_secondary_path2, new_secondary_defs;
function new_secondary_extends() { new_secondary_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return new_secondary_extends.apply(this, arguments); }

var SvgNewSecondary = function SvgNewSecondary(props) {
  return /*#__PURE__*/react.createElement("svg", new_secondary_extends({
    width: 25,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), new_secondary_path || (new_secondary_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8h17v2a8 8 0 0 1-8 8H0V8Z",
    fill: "url(#new-secondary_svg__a)"
  })), new_secondary_path2 || (new_secondary_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M4.664 8V2.4h1.072L9.04 6.432h-.52V2.4H9.8V8H8.736L5.424 3.968h.52V8h-1.28Zm8.349.064c-.49 0-.923-.096-1.296-.288a2.14 2.14 0 0 1-.856-.784 2.172 2.172 0 0 1-.304-1.144c0-.432.099-.813.296-1.144.203-.336.477-.597.824-.784a2.386 2.386 0 0 1 1.176-.288c.421 0 .8.09 1.136.272.341.176.61.432.808.768.197.33.296.728.296 1.192 0 .048-.003.104-.008.168l-.016.168h-3.496v-.728h2.84l-.48.216c0-.224-.045-.419-.136-.584a.965.965 0 0 0-.376-.384 1.067 1.067 0 0 0-.56-.144 1.11 1.11 0 0 0-.568.144.953.953 0 0 0-.376.392c-.09.165-.136.363-.136.592v.192c0 .235.05.443.152.624.107.176.253.312.44.408.192.09.416.136.672.136a1.46 1.46 0 0 0 1.08-.416l.664.72a1.972 1.972 0 0 1-.744.52 2.808 2.808 0 0 1-1.032.176ZM16.67 8l-1.552-4.304h1.176L17.582 7.4h-.56l1.344-3.704h1.056L20.726 7.4h-.56l1.328-3.704h1.104L21.038 8H19.83l-1.144-3.176h.368L17.87 8h-1.2Z",
    fill: "#fff"
  })), new_secondary_defs || (new_secondary_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "new-secondary_svg__a",
    x1: 30.833,
    y1: 1.667,
    x2: 2.592,
    y2: 15.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.076,
    stopColor: "#FFB5E8"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.74,
    stopColor: "#B91D73"
  })))));
};
/* harmony default export */ var new_secondary = (SvgNewSecondary);
;// CONCATENATED MODULE: ./src/svgs/coming-secondary.svg
var coming_secondary_path, coming_secondary_path2, coming_secondary_defs;
function coming_secondary_extends() { coming_secondary_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return coming_secondary_extends.apply(this, arguments); }

var SvgComingSecondary = function SvgComingSecondary(props) {
  return /*#__PURE__*/react.createElement("svg", coming_secondary_extends({
    width: 45,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), coming_secondary_path || (coming_secondary_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 11.052C0 4.948 4.948 0 11.052 0h28.631c2.554 0 4.307 2.571 3.373 4.949a10.87 10.87 0 0 1-9.415 6.872L2.94 13.81A2.763 2.763 0 0 1 0 11.052Z",
    fill: "url(#coming-secondary_svg__a)"
  })), coming_secondary_path2 || (coming_secondary_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.071 9.596c-.432 0-.834-.07-1.208-.208a2.855 2.855 0 0 1-1.6-1.528A2.94 2.94 0 0 1 4.04 6.7c0-.421.075-.808.224-1.16.155-.352.368-.659.64-.92.278-.261.6-.461.968-.6.368-.144.77-.216 1.208-.216.486 0 .923.085 1.312.256.395.165.726.41.992.736l-.832.768a1.898 1.898 0 0 0-.64-.488 1.76 1.76 0 0 0-.768-.168c-.261 0-.501.043-.72.128a1.632 1.632 0 0 0-.568.368c-.16.16-.285.35-.376.568a1.987 1.987 0 0 0-.128.728c0 .267.043.51.128.728.09.219.216.408.376.568.16.16.35.283.568.368.219.085.459.128.72.128.278 0 .534-.053.768-.16.235-.112.448-.28.64-.504l.832.768a2.593 2.593 0 0 1-.992.744c-.39.17-.83.256-1.32.256Zm5.63 0c-.443 0-.853-.072-1.232-.216a2.96 2.96 0 0 1-.976-.608 2.855 2.855 0 0 1-.64-.92A2.92 2.92 0 0 1 9.63 6.7c0-.416.075-.8.224-1.152.155-.352.37-.659.648-.92a2.96 2.96 0 0 1 .976-.608 3.35 3.35 0 0 1 1.216-.216c.443 0 .848.072 1.216.216a2.87 2.87 0 0 1 1.616 1.528c.155.347.232.73.232 1.152 0 .416-.077.803-.232 1.16-.155.352-.37.659-.648.92a2.937 2.937 0 0 1-.968.6c-.368.144-.77.216-1.208.216Zm-.008-1.104c.25 0 .48-.043.688-.128a1.65 1.65 0 0 0 .928-.936c.09-.219.136-.461.136-.728 0-.267-.045-.51-.136-.728a1.632 1.632 0 0 0-.368-.568 1.568 1.568 0 0 0-.552-.368 1.857 1.857 0 0 0-.696-.128c-.25 0-.482.043-.696.128a1.67 1.67 0 0 0-.552.368c-.16.16-.285.35-.376.568a1.988 1.988 0 0 0-.128.728c0 .261.043.504.128.728.09.219.213.408.368.568.16.16.347.283.56.368.213.085.446.128.696.128ZM16.571 9.5V3.9h1.072l2.384 3.952h-.568L21.803 3.9h1.064l.016 5.6h-1.216l-.008-3.736h.224l-1.872 3.144h-.584l-1.912-3.144h.272V9.5h-1.216Zm7.48 0V3.9h1.297v5.6h-1.296Zm2.466 0V3.9h1.072l3.304 4.032h-.52V3.9h1.28v5.6h-1.064l-3.312-4.032h.52V9.5h-1.28Zm9.005.096c-.443 0-.85-.07-1.224-.208a2.978 2.978 0 0 1-.968-.608 2.854 2.854 0 0 1-.64-.92 2.939 2.939 0 0 1-.224-1.16c0-.421.074-.808.224-1.16.154-.352.37-.659.648-.92.277-.261.602-.461.976-.6a3.396 3.396 0 0 1 1.232-.216c.496 0 .941.083 1.336.248.4.165.736.405 1.008.72l-.832.768a1.979 1.979 0 0 0-.664-.472 1.909 1.909 0 0 0-.784-.16c-.272 0-.52.043-.744.128a1.699 1.699 0 0 0-.584.368c-.16.16-.286.35-.376.568a1.986 1.986 0 0 0-.128.728c0 .261.042.501.128.72.09.219.216.41.376.576.165.16.357.283.576.368.224.085.47.128.736.128.256 0 .504-.04.744-.12a2.21 2.21 0 0 0 .712-.424l.736.936a3.37 3.37 0 0 1-1.064.528c-.4.123-.8.184-1.2.184Zm1.08-.88V6.612h1.184v2.272l-1.184-.168Z",
    fill: "#fff"
  })), coming_secondary_defs || (coming_secondary_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "coming-secondary_svg__a",
    x1: 42.534,
    y1: 0,
    x2: -3.783,
    y2: 14.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#00C9FF"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#92FE9D"
  })))));
};
/* harmony default export */ var coming_secondary = (SvgComingSecondary);
;// CONCATENATED MODULE: ./src/svgs/referral.svg
var referral_path, referral_path2, referral_path3;
function referral_extends() { referral_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return referral_extends.apply(this, arguments); }

var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/react.createElement("svg", referral_extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), referral_path || (referral_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.97 3.044A3.944 3.944 0 0 0 19 1.714a3.995 3.995 0 0 0-4 4c0 .75.21 1.46.58 2.06.2.34.46.65.76.91.7.64 1.63 1.03 2.66 1.03.44 0 .86-.07 1.25-.21.92-.29 1.69-.92 2.17-1.73.21-.34.37-.73.46-1.13.08-.3.12-.61.12-.93 0-1.02-.39-1.96-1.03-2.67Zm-1.48 3.4h-.74v.78c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.78h-.74c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.74v-.71c0-.41.34-.75.75-.75s.75.34.75.75v.71h.74a.749.749 0 1 1 0 1.5Z"
  })), referral_path2 || (referral_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M22 12.714c0-1.31-.25-2.57-.72-3.72-.31.22-.66.39-1.03.51-.11.04-.22.07-.34.1a8.48 8.48 0 0 1-1.87 9.08c-.29-.37-.66-.71-1.1-1-2.71-1.82-7.15-1.82-9.88 0-.44.29-.8.63-1.1 1a8.48 8.48 0 0 1-2.46-5.97c0-4.69 3.81-8.5 8.5-8.5 1.09 0 2.14.21 3.1.59.03-.12.06-.23.1-.35.12-.37.29-.71.52-1.02a9.82 9.82 0 0 0-3.72-.72c-5.51 0-10 4.49-10 10 0 2.9 1.25 5.51 3.23 7.34 0 .01 0 .01-.01.02.1.1.22.18.32.27.06.05.11.1.17.14.18.15.38.29.57.43l.2.14c.19.13.39.25.6.36.07.04.15.09.22.13.2.11.41.21.63.3.08.04.16.08.24.11.22.09.44.17.66.24.08.03.16.06.24.08.24.07.48.13.72.19.07.02.14.04.22.05.28.06.56.1.85.13.04 0 .08.01.12.02.34.03.68.05 1.02.05.34 0 .68-.02 1.01-.05.04 0 .08-.01.12-.02.29-.03.57-.07.85-.13.07-.01.14-.04.22-.05.24-.06.49-.11.72-.19.08-.03.16-.06.24-.08.22-.08.45-.15.66-.24.08-.03.16-.07.24-.11.21-.09.42-.19.63-.3.08-.04.15-.09.22-.13.2-.12.4-.23.6-.36.07-.04.13-.09.2-.14.2-.14.39-.28.57-.43.06-.05.11-.1.17-.14.11-.09.22-.18.32-.27 0-.01 0-.01-.01-.02 1.99-1.83 3.24-4.44 3.24-7.34Z"
  })), referral_path3 || (referral_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M12 7.644c-2.07 0-3.75 1.68-3.75 3.75 0 2.03 1.59 3.68 3.7 3.74h.18a3.743 3.743 0 0 0 3.62-3.74c0-2.07-1.68-3.75-3.75-3.75Z"
  })));
};
/* harmony default export */ var referral = (SvgReferral);
;// CONCATENATED MODULE: ./src/svgs/jar.svg
var jar_path;
function jar_extends() { jar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return jar_extends.apply(this, arguments); }

var SvgJar = function SvgJar(props) {
  return /*#__PURE__*/react.createElement("svg", jar_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jar_path || (jar_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.089 6.896c-.41 0-.78-.378-.78-.795 0-.963 2.382-1.675 5.092-1.675.245 0 .41 0 .41-.208 0-.377-.821-.502-.821-1.13 0-.67.78-1.088 1.766-1.088s1.766.418 1.766 1.088c0 .628-.821.711-.821 1.13 0 .125.123.209.41.209 2.71 0 5.133.669 5.133 1.674a.787.787 0 0 1-.78.794H6.088Zm12.277 3.807c.986.627 1.355 1.757 1.191 2.804l-1.15 6.316C18.161 21.081 17.092 22 15.82 22H7.772c-1.271 0-2.34-.92-2.586-2.176l-1.15-6.317a2.756 2.756 0 0 1 1.233-2.763c.575-.417.697-1.129 0-1.38-.987-.377-.782-1.59.204-1.59h5.994c.944 0 2.095.711 2.095 3.013 0 2.301-1.068 2.091-1.068 3.723 0 .712.575 1.465 1.273 1.55 1.191.124 1.889-.336 1.889-2.01 0-1.716-.985-2.51-.985-3.933 0-1.715 1.066-2.385 1.765-2.385h1.725c.985 0 1.191 1.214.205 1.59-.698.292-.575 1.005 0 1.38Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var jar = (SvgJar);
;// CONCATENATED MODULE: ./src/svgs/arrow-up.svg
var arrow_up_g, arrow_up_defs;
function arrow_up_extends() { arrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_up_extends.apply(this, arguments); }

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_up_extends({
    width: 25,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_up_g || (arrow_up_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#arrow-up_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "m8.62 14.71 3.88-3.88 3.88 3.88a.996.996 0 1 0 1.41-1.41L13.2 8.71a.996.996 0 0 0-1.41 0L7.2 13.3a.996.996 0 0 0 0 1.41c.39.38 1.03.39 1.42 0Z"
  }))), arrow_up_defs || (arrow_up_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "arrow-up_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    transform: "rotate(-180 12.25 12)",
    d: "M0 0h24v24H0z"
  })))));
};
/* harmony default export */ var arrow_up = (SvgArrowUp);
;// CONCATENATED MODULE: ./src/svgs/arrow-down.svg
var arrow_down_path;
function arrow_down_extends() { arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_extends.apply(this, arguments); }

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_down_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_down_path || (arrow_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.724 6.641a.625.625 0 0 1 .814-.06l.07.06 5.391 5.391 5.392-5.39a.625.625 0 0 1 .813-.061l.07.06c.223.222.243.57.061.814l-.06.07-5.834 5.833a.625.625 0 0 1-.813.06l-.07-.06-5.834-5.833a.625.625 0 0 1 0-.884Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var arrow_down = (SvgArrowDown);
;// CONCATENATED MODULE: ./src/svgs/arrow-down-alt.svg
var arrow_down_alt_g, arrow_down_alt_defs;
function arrow_down_alt_extends() { arrow_down_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_alt_extends.apply(this, arguments); }

var SvgArrowDownAlt = function SvgArrowDownAlt(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_down_alt_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrow_down_alt_g || (arrow_down_alt_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#arrow-down-alt_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13.233 7.742 10 10.975 6.767 7.742a.83.83 0 1 0-1.175 1.175l3.825 3.825a.83.83 0 0 0 1.175 0l3.825-3.825a.83.83 0 0 0 0-1.175.848.848 0 0 0-1.184 0Z",
    fill: "#E0E0E0"
  }))), arrow_down_alt_defs || (arrow_down_alt_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "arrow-down-alt_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
/* harmony default export */ var arrow_down_alt = (SvgArrowDownAlt);
;// CONCATENATED MODULE: ./src/svgs/copy-right.svg
var copy_right_path;
function copy_right_extends() { copy_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return copy_right_extends.apply(this, arguments); }

var SvgCopyRight = function SvgCopyRight(props) {
  return /*#__PURE__*/react.createElement("svg", copy_right_extends({
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, props), copy_right_path || (copy_right_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.88 9.14c1.28.06 1.61 1.15 1.63 1.66h1.79c-.08-1.98-1.49-3.19-3.45-3.19C9.64 7.61 8 9 8 12.14c0 1.94.93 4.24 3.84 4.24 2.22 0 3.41-1.65 3.44-2.95h-1.79c-.03.59-.45 1.38-1.63 1.44-1.31-.04-1.86-1.06-1.86-2.73 0-2.89 1.28-2.98 1.88-3zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  })));
};
/* harmony default export */ var copy_right = (SvgCopyRight);
;// CONCATENATED MODULE: ./src/svgs/copy-icon.svg
var copy_icon_path, copy_icon_path2, copy_icon_path3;
function copy_icon_extends() { copy_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return copy_icon_extends.apply(this, arguments); }

var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/react.createElement("svg", copy_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), copy_icon_path || (copy_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.5 13.15h-2.17c-1.78 0-3.23-1.44-3.23-3.23V7.75c0-.41-.33-.75-.75-.75H6.18C3.87 7 2 8.5 2 11.18v6.64C2 20.5 3.87 22 6.18 22h5.89c2.31 0 4.18-1.5 4.18-4.18V13.9c0-.42-.34-.75-.75-.75Z"
  })), copy_icon_path2 || (copy_icon_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M17.82 2H11.93C9.67 2 7.84 3.44 7.76 6.01c.06 0 .11-.01.17-.01h5.89C16.13 6 18 7.5 18 10.18V16.83c0 .06-.01.11-.01.16 2.23-.07 4.01-1.55 4.01-4.16V6.18C22 3.5 20.13 2 17.82 2Z"
  })), copy_icon_path3 || (copy_icon_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M11.98 7.15c-.31-.31-.84-.1-.84.33v2.62c0 1.1.93 2 2.07 2 .71.01 1.7.01 2.55.01.43 0 .65-.5.35-.8-1.09-1.09-3.03-3.04-4.13-4.16Z"
  })));
};
/* harmony default export */ var copy_icon = (SvgCopyIcon);
;// CONCATENATED MODULE: ./src/svgs/copy-icon-outline.svg
var copy_icon_outline_path;
function copy_icon_outline_extends() { copy_icon_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return copy_icon_outline_extends.apply(this, arguments); }

var SvgCopyIconOutline = function SvgCopyIconOutline(props) {
  return /*#__PURE__*/react.createElement("svg", copy_icon_outline_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), copy_icon_outline_path || (copy_icon_outline_path = /*#__PURE__*/react.createElement("path", {
    d: "M16 20H6V7c0-.55-.45-1-1-1s-1 .45-1 1v13c0 1.1.9 2 2 2h10c.55 0 1-.45 1-1s-.45-1-1-1Zm5-4V4c0-1.1-.9-2-2-2h-9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2Zm-2 0h-9V4h9v12Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var copy_icon_outline = (SvgCopyIconOutline);
;// CONCATENATED MODULE: ./src/svgs/email-default.svg
var email_default_path, email_default_path2, email_default_g;
function email_default_extends() { email_default_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return email_default_extends.apply(this, arguments); }

var SvgEmailDefault = function SvgEmailDefault(props) {
  return /*#__PURE__*/react.createElement("svg", email_default_extends({
    width: 19,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), email_default_path || (email_default_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.813 10.221a2.535 2.535 0 0 1-1.578-.552L4.498 6.655a.626.626 0 0 1 .784-.973l3.734 3.01c.47.372 1.13.372 1.602-.003l3.697-3.005a.624.624 0 1 1 .79.97L11.4 9.664a2.55 2.55 0 0 1-1.588.557Z"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "email-default_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 17
  }, email_default_path2 || (email_default_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.833.667H18.75v16.25H.833V.667Z",
    fill: "#fff"
  }))), email_default_g || (email_default_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#email-default_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.699 15.667h8.183c.002-.002.008 0 .014 0 .95 0 1.794-.34 2.44-.986.751-.747 1.164-1.821 1.164-3.024V5.934c0-2.328-1.522-4.017-3.618-4.017H5.701c-2.096 0-3.618 1.69-3.618 4.017v5.723c0 1.203.413 2.277 1.163 3.024.647.646 1.491.986 2.441.986H5.7Zm-.014 1.25c-1.286 0-2.434-.467-3.321-1.35-.988-.985-1.531-2.373-1.531-3.91V5.934C.833 2.93 2.926.667 5.701.667h8.181c2.775 0 4.868 2.264 4.868 5.267v5.723c0 1.537-.544 2.925-1.531 3.91-.886.883-2.035 1.35-3.324 1.35H5.686Z"
  }))));
};
/* harmony default export */ var email_default = (SvgEmailDefault);
;// CONCATENATED MODULE: ./src/svgs/close-circle.svg
var close_circle_path;
function close_circle_extends() { close_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_circle_extends.apply(this, arguments); }

var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/react.createElement("svg", close_circle_extends({
    viewBox: "0 0 24 24"
  }, props), close_circle_path || (close_circle_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
  })));
};
/* harmony default export */ var close_circle = (SvgCloseCircle);
;// CONCATENATED MODULE: ./src/svgs/close-stroke.svg
var close_stroke_path, close_stroke_path2, close_stroke_path3;
function close_stroke_extends() { close_stroke_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_stroke_extends.apply(this, arguments); }

var SvgCloseStroke = function SvgCloseStroke(props) {
  return /*#__PURE__*/react.createElement("svg", close_stroke_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), close_stroke_path || (close_stroke_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 18.958c-4.942 0-8.959-4.016-8.959-8.958s4.017-8.958 8.958-8.958c4.942 0 8.959 4.016 8.959 8.958 0 4.941-4.017 8.958-8.959 8.958Zm0-16.666C5.75 2.291 2.29 5.75 2.29 10s3.458 7.708 7.708 7.708S17.708 14.25 17.708 10s-3.459-7.708-7.709-7.708Z"
  })), close_stroke_path2 || (close_stroke_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.642 12.983a.618.618 0 0 1-.441-.183.629.629 0 0 1 0-.884L11.917 7.2a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .883L8.084 12.8a.604.604 0 0 1-.442.183Z"
  })), close_stroke_path3 || (close_stroke_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M12.36 12.983a.618.618 0 0 1-.443-.183L7.201 8.083a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l4.717 4.716a.629.629 0 0 1 0 .884.618.618 0 0 1-.442.183Z"
  })));
};
/* harmony default export */ var close_stroke = (SvgCloseStroke);
;// CONCATENATED MODULE: ./src/svgs/close.svg
var close_path;
function close_extends() { close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_extends.apply(this, arguments); }

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/react.createElement("svg", close_extends({
    width: 24,
    height: 24,
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), close_path || (close_path = /*#__PURE__*/react.createElement("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  })));
};
/* harmony default export */ var svgs_close = (SvgClose);
;// CONCATENATED MODULE: ./src/svgs/fullscreen.svg
var fullscreen_path;
function fullscreen_extends() { fullscreen_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fullscreen_extends.apply(this, arguments); }

var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/react.createElement("svg", fullscreen_extends({
    width: 24,
    height: 24,
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), fullscreen_path || (fullscreen_path = /*#__PURE__*/react.createElement("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
  })));
};
/* harmony default export */ var fullscreen = (SvgFullscreen);
;// CONCATENATED MODULE: ./src/svgs/play.svg
var play_path;
function play_extends() { play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return play_extends.apply(this, arguments); }

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/react.createElement("svg", play_extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), play_path || (play_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.012C0 8.972 8.977 0 20 0s20 8.973 20 20.012C40 31.027 31.023 40 20 40S0 31.027 0 20.012Zm27.336 2.024c.212-.213.483-.54.54-.618.31-.405.464-.907.464-1.406 0-.562-.174-1.083-.502-1.507-.027-.027-.08-.085-.148-.16-.129-.14-.313-.34-.49-.516-1.582-1.698-5.713-4.476-7.876-5.325-.328-.133-1.158-.425-1.602-.444-.425 0-.83.096-1.216.29-.483.27-.869.694-1.081 1.196-.135.347-.348 1.389-.348 1.408-.212 1.139-.328 2.991-.328 5.036 0 1.951.116 3.724.29 4.882.004.005.021.088.047.216.078.391.242 1.206.416 1.54a2.43 2.43 0 0 0 2.143 1.312h.077c.58-.02 1.795-.52 1.795-.54 2.047-.85 6.082-3.493 7.703-5.248l.116-.116Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var play = (SvgPlay);
;// CONCATENATED MODULE: ./src/svgs/rotate-right.svg
var rotate_right_path;
function rotate_right_extends() { rotate_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rotate_right_extends.apply(this, arguments); }

var SvgRotateRight = function SvgRotateRight(props) {
  return /*#__PURE__*/react.createElement("svg", rotate_right_extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), rotate_right_path || (rotate_right_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.242 17.242a6.04 6.04 0 0 1-1.37 1.027l.961 1.754a8.068 8.068 0 0 0 2.569-2.225l-1.6-1.201a5.938 5.938 0 0 1-.56.645zm1.743-4.671a5.975 5.975 0 0 1-.362 2.528l1.873.701a7.977 7.977 0 0 0 .483-3.371l-1.994.142zm1.512-2.368a8.048 8.048 0 0 0-1.841-2.859l-1.414 1.414a6.071 6.071 0 0 1 1.382 2.146l1.873-.701zm-8.128 8.763c-.047-.005-.094-.015-.141-.021a6.701 6.701 0 0 1-.468-.075 5.923 5.923 0 0 1-2.421-1.122 5.954 5.954 0 0 1-.583-.506 6.138 6.138 0 0 1-.516-.597 5.91 5.91 0 0 1-.891-1.634 6.086 6.086 0 0 1-.247-.902c-.008-.043-.012-.088-.019-.131A6.332 6.332 0 0 1 6 13.002V13c0-1.603.624-3.109 1.758-4.242A5.944 5.944 0 0 1 11 7.089V10l5-4-5-4v3.069a7.917 7.917 0 0 0-4.656 2.275A7.936 7.936 0 0 0 4 12.999v.009c0 .253.014.504.037.753.007.076.021.15.03.227.021.172.044.345.076.516.019.1.044.196.066.295.032.142.065.283.105.423.032.112.07.223.107.333.026.079.047.159.076.237l.008-.003A7.948 7.948 0 0 0 5.6 17.785l-.007.005c.021.028.049.053.07.081.211.272.433.538.681.785a8.236 8.236 0 0 0 .966.816c.265.192.537.372.821.529l.028.019.001-.001a7.877 7.877 0 0 0 2.136.795l-.001.005.053.009c.201.042.405.071.61.098.069.009.138.023.207.03a8.038 8.038 0 0 0 2.532-.137l-.424-1.955a6.11 6.11 0 0 1-1.904.102z",
    fill: "#FFF"
  })));
};
/* harmony default export */ var rotate_right = (SvgRotateRight);
;// CONCATENATED MODULE: ./src/svgs/rotate-left.svg
var rotate_left_path;
function rotate_left_extends() { rotate_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rotate_left_extends.apply(this, arguments); }

var SvgRotateLeft = function SvgRotateLeft(props) {
  return /*#__PURE__*/react.createElement("svg", rotate_left_extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), rotate_left_path || (rotate_left_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.758 8.758 5.344 7.344a8.048 8.048 0 0 0-1.841 2.859l1.873.701a6.048 6.048 0 0 1 1.382-2.146zM19 12.999a7.935 7.935 0 0 0-2.344-5.655A7.917 7.917 0 0 0 12 5.069V2L7 6l5 4V7.089a5.944 5.944 0 0 1 3.242 1.669A5.956 5.956 0 0 1 17 13v.002c0 .33-.033.655-.086.977-.007.043-.011.088-.019.131a6.053 6.053 0 0 1-1.138 2.536c-.16.209-.331.412-.516.597a5.954 5.954 0 0 1-.728.613 5.906 5.906 0 0 1-2.277 1.015c-.142.03-.285.05-.43.069-.062.009-.122.021-.184.027a6.104 6.104 0 0 1-1.898-.103L9.3 20.819a8.087 8.087 0 0 0 2.534.136c.069-.007.138-.021.207-.03.205-.026.409-.056.61-.098l.053-.009-.001-.005a7.877 7.877 0 0 0 2.136-.795l.001.001.028-.019a7.906 7.906 0 0 0 1.01-.67c.27-.209.532-.43.777-.675.248-.247.47-.513.681-.785.021-.028.049-.053.07-.081l-.006-.004a7.899 7.899 0 0 0 1.093-1.997l.008.003c.029-.078.05-.158.076-.237.037-.11.075-.221.107-.333.04-.14.073-.281.105-.423.022-.099.048-.195.066-.295.032-.171.056-.344.076-.516.01-.076.023-.15.03-.227.023-.249.037-.5.037-.753.002-.002.002-.004.002-.008zM6.197 16.597l-1.6 1.201a8.045 8.045 0 0 0 2.569 2.225l.961-1.754a6.018 6.018 0 0 1-1.93-1.672zM5 13c0-.145.005-.287.015-.429l-1.994-.143a7.977 7.977 0 0 0 .483 3.372l1.873-.701A5.975 5.975 0 0 1 5 13z",
    fill: "#FFF"
  })));
};
/* harmony default export */ var rotate_left = (SvgRotateLeft);
;// CONCATENATED MODULE: ./src/svgs/zoom-out.svg
var zoom_out_path;
function zoom_out_extends() { zoom_out_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return zoom_out_extends.apply(this, arguments); }

var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/react.createElement("svg", zoom_out_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), zoom_out_path || (zoom_out_path = /*#__PURE__*/react.createElement("path", {
    d: "m20 20-5.05-5.05m0 0a7 7 0 1 0-9.9-9.9 7 7 0 0 0 9.9 9.9ZM7 10h6",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var zoom_out = (SvgZoomOut);
;// CONCATENATED MODULE: ./src/svgs/zoom-in.svg
var zoom_in_path;
function zoom_in_extends() { zoom_in_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return zoom_in_extends.apply(this, arguments); }

var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/react.createElement("svg", zoom_in_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), zoom_in_path || (zoom_in_path = /*#__PURE__*/react.createElement("path", {
    d: "m20 20-5.05-5.05m0 0a7 7 0 1 0-9.9-9.9 7 7 0 0 0 9.9 9.9ZM7 10h6m-3-3v6",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var zoom_in = (SvgZoomIn);
;// CONCATENATED MODULE: ./src/svgs/search.svg
var search_path;
function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/react.createElement("svg", search_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), search_path || (search_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.584 18.125c-4.709 0-8.542-3.833-8.542-8.542 0-4.708 3.833-8.541 8.542-8.541 4.708 0 8.541 3.833 8.541 8.541 0 4.709-3.833 8.542-8.541 8.542Zm0-15.833c-4.025 0-7.292 3.275-7.292 7.291 0 4.017 3.267 7.292 7.292 7.292s7.291-3.275 7.291-7.292c0-4.016-3.266-7.291-7.291-7.291ZM18.334 18.958a.618.618 0 0 1-.442-.183l-1.667-1.667a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l1.667 1.667a.629.629 0 0 1 0 .883.618.618 0 0 1-.441.183Z",
    fill: "#E0E0E0"
  })));
};
/* harmony default export */ var search = (SvgSearch);
;// CONCATENATED MODULE: ./src/svgs/chevron-left.svg
var chevron_left_path;
function chevron_left_extends() { chevron_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_left_extends.apply(this, arguments); }

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_left_extends({
    viewBox: "0 0 9 18"
  }, props), chevron_left_path || (chevron_left_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 17.67c-.19 0-.38-.07-.53-.22L.95 10.93a2.74 2.74 0 0 1 0-3.86L7.47.55c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L2.01 8.13c-.48.48-.48 1.26 0 1.74l6.52 6.52c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22Z"
  })));
};
/* harmony default export */ var chevron_left = (SvgChevronLeft);
;// CONCATENATED MODULE: ./src/svgs/chevron-right.svg
var chevron_right_path;
function chevron_right_extends() { chevron_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_right_extends.apply(this, arguments); }

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react.createElement("svg", chevron_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 18"
  }, props), chevron_right_path || (chevron_right_path = /*#__PURE__*/react.createElement("path", {
    d: "M1 .33c.19 0 .38.07.53.22l6.52 6.52a2.74 2.74 0 0 1 0 3.86l-6.52 6.52c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l6.52-6.52c.48-.48.48-1.26 0-1.74L.47 1.61a.754.754 0 0 1 0-1.06C.62.41.81.33 1 .33Z"
  })));
};
/* harmony default export */ var chevron_right = (SvgChevronRight);
;// CONCATENATED MODULE: ./src/svgs/clear.svg
var clear_path;
function clear_extends() { clear_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clear_extends.apply(this, arguments); }

var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/react.createElement("svg", clear_extends({
    viewBox: "0 0 24 24"
  }, props), clear_path || (clear_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
  })));
};
/* harmony default export */ var clear = (SvgClear);
;// CONCATENATED MODULE: ./src/svgs/back.svg
var back_path;
function back_extends() { back_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return back_extends.apply(this, arguments); }

var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/react.createElement("svg", back_extends({
    viewBox: "0 0 24 24"
  }, props), back_path || (back_path = /*#__PURE__*/react.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  })));
};
/* harmony default export */ var back = (SvgBack);
;// CONCATENATED MODULE: ./src/svgs/home-outline.svg
var home_outline_path, home_outline_path2;
function home_outline_extends() { home_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return home_outline_extends.apply(this, arguments); }

var SvgHomeOutline = function SvgHomeOutline(props) {
  return /*#__PURE__*/react.createElement("svg", home_outline_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), home_outline_path || (home_outline_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.79 22.75H6.21c-2.74 0-4.96-2.23-4.96-4.97v-7.41c0-1.36.84-3.07 1.92-3.91l5.39-4.2C10.18 1 12.77.94 14.45 2.12l6.18 4.33c1.19.83 2.12 2.61 2.12 4.06v7.28c0 2.73-2.22 4.96-4.96 4.96ZM9.48 3.44l-5.39 4.2c-.71.56-1.34 1.83-1.34 2.73v7.41a3.47 3.47 0 0 0 3.46 3.47h11.58c1.91 0 3.46-1.55 3.46-3.46v-7.28c0-.96-.69-2.29-1.48-2.83l-6.18-4.33c-1.14-.8-3.02-.76-4.11.09Z",
    fill: "#E0E0E0"
  })), home_outline_path2 || (home_outline_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12 18.75c-.41 0-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75Z",
    fill: "#E0E0E0"
  })));
};
/* harmony default export */ var home_outline = (SvgHomeOutline);
;// CONCATENATED MODULE: ./src/svgs/login.svg
var login_path, login_path2, login_path3;
function login_extends() { login_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return login_extends.apply(this, arguments); }

var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/react.createElement("svg", login_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), login_path || (login_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.24 22.27h-.13c-4.44 0-6.58-1.75-6.95-5.67-.04-.41.26-.78.68-.82.41-.04.78.27.82.68.29 3.14 1.77 4.31 5.46 4.31h.13c4.07 0 5.51-1.44 5.51-5.51V8.74c0-4.07-1.44-5.51-5.51-5.51h-.13c-3.71 0-5.19 1.19-5.46 4.39-.05.41-.39.72-.82.68a.751.751 0 0 1-.69-.81c.34-3.98 2.49-5.76 6.96-5.76h.13c4.91 0 7.01 2.1 7.01 7.01v6.52c0 4.91-2.1 7.01-7.01 7.01Z",
    fill: "#ADADAD"
  })), login_path2 || (login_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M14.88 12.75H2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12.88a.749.749 0 1 1 0 1.5Z",
    fill: "#ADADAD"
  })), login_path3 || (login_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M12.65 16.1c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L14.94 12l-2.82-2.82a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.35 3.35c.29.29.29.77 0 1.06l-3.35 3.35c-.15.15-.34.22-.53.22Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var login = (SvgLogin);
;// CONCATENATED MODULE: ./src/svgs/support-outline.svg
var support_outline_path, support_outline_path2;
function support_outline_extends() { support_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return support_outline_extends.apply(this, arguments); }

var SvgSupportOutline = function SvgSupportOutline(props) {
  return /*#__PURE__*/react.createElement("svg", support_outline_extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), support_outline_path || (support_outline_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.666 22.32c-.28 0-.57-.07-.83-.21-.57-.3-.92-.9-.92-1.54v-1.42c-3.02-.31-5-2.53-5-5.71v-6c0-3.44 2.31-5.75 5.75-5.75h10c3.44 0 5.75 2.31 5.75 5.75v6c0 3.44-2.31 5.75-5.75 5.75h-3.77l-4.26 2.84c-.29.19-.63.29-.97.29Zm-1-19.14c-2.58 0-4.25 1.67-4.25 4.25v6c0 2.58 1.67 4.25 4.25 4.25.41 0 .75.34.75.75v2.13c0 .13.08.19.13.22s.15.06.26-.01l4.45-2.96c.12-.08.27-.13.42-.13h4c2.58 0 4.25-1.67 4.25-4.25v-6c0-2.58-1.67-4.25-4.25-4.25H7.666Z",
    fill: "#ADADAD"
  })), support_outline_path2 || (support_outline_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.666 12.11c-.41 0-.75-.34-.75-.75v-.21c0-1.16.85-1.73 1.17-1.95.37-.25.49-.42.49-.68 0-.5-.41-.91-.91-.91s-.91.41-.91.91c0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-1.33 1.08-2.41 2.41-2.41s2.41 1.08 2.41 2.41c0 1.14-.84 1.71-1.15 1.92-.39.26-.51.43-.51.71v.21c0 .42-.34.75-.75.75ZM12.666 14.6a.749.749 0 1 1-.002-1.498.749.749 0 0 1 .002 1.498Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var support_outline = (SvgSupportOutline);
;// CONCATENATED MODULE: ./src/svgs/hpd-navigation-icon.svg
var hpd_navigation_icon_circle, hpd_navigation_icon_g, hpd_navigation_icon_defs;
function hpd_navigation_icon_extends() { hpd_navigation_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hpd_navigation_icon_extends.apply(this, arguments); }

var SvgHpdNavigationIcon = function SvgHpdNavigationIcon(props) {
  return /*#__PURE__*/react.createElement("svg", hpd_navigation_icon_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), hpd_navigation_icon_circle || (hpd_navigation_icon_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    stroke: "#fff",
    strokeWidth: 1.5
  })), hpd_navigation_icon_g || (hpd_navigation_icon_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#hpd-navigation-icon_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M17.16 12.207a5.829 5.829 0 0 1-.645.702v3.437a1.137 1.137 0 0 1-2.274 0v-2.973a5.228 5.228 0 0 0 3.383-4.885V7.074a2.289 2.289 0 0 0-1.147-1.588 2.243 2.243 0 0 0-1.099-.28 2.286 2.286 0 0 0-2.282 2.282v4.182c.072-.016.145-.034.214-.054.054-.016.108-.032.16-.05.011-.006.024-.009.036-.014a2.798 2.798 0 0 0 .365-.157c.06-.031.13-.07.19-.107l.01-.007c.052-.031.1-.06.15-.097a.06.06 0 0 0 .021-.014V7.488a1.141 1.141 0 0 1 1.419-1.103 1.14 1.14 0 0 1 .819.816V8.49a4.077 4.077 0 0 1-3.387 4.013 4.024 4.024 0 0 1-1.31.013 4.077 4.077 0 0 1-3.42-3.483V7.488a1.14 1.14 0 0 1 1.136-1.141 1.14 1.14 0 0 1 1.139 1.14v3.737c.114.073.233.14.355.198.098.049.198.092.3.13l.087.03c.023.007.046.014.067.022l.107.03.115.029.114.024v-4.2a2.286 2.286 0 0 0-2.637-2.253 2.285 2.285 0 0 0-1.93 2.254v1.62a5.228 5.228 0 0 0 3.422 4.294v2.942a1.137 1.137 0 0 1-2.274 0v-3.368a6.207 6.207 0 0 1-1.149-1.388v4.76a2.284 2.284 0 0 0 4.568 0v-2.675a5.115 5.115 0 0 0 1.31-.008v2.682a2.284 2.284 0 1 0 4.567 0v-4.889a6.034 6.034 0 0 1-.5.749Z",
    fill: "#fff"
  }))), hpd_navigation_icon_defs || (hpd_navigation_icon_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "hpd-navigation-icon_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(7.217 5.203)",
    d: "M0 0h10.445v13.427H0z"
  })))));
};
/* harmony default export */ var hpd_navigation_icon = (SvgHpdNavigationIcon);
;// CONCATENATED MODULE: ./src/svgs/cashback.svg
var cashback_path, cashback_path2;
function cashback_extends() { cashback_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cashback_extends.apply(this, arguments); }

var SvgCashback = function SvgCashback(props) {
  return /*#__PURE__*/react.createElement("svg", cashback_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), cashback_path || (cashback_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.18 11.389c-1.362-.328-1.8-.667-1.8-1.195 0-.605.606-1.027 1.62-1.027.852 0 1.278.3 1.434.777.072.223.27.39.522.39h.18c.396 0 .678-.362.54-.706-.252-.656-.84-1.2-1.776-1.411v-.384c0-.46-.402-.833-.9-.833s-.9.372-.9.833V8.2c-1.164.233-2.1.933-2.1 2.006 0 1.283 1.146 1.922 2.82 2.294 1.5.333 1.8.822 1.8 1.339 0 .383-.294.994-1.62.994-.99 0-1.5-.327-1.698-.794a.587.587 0 0 0-.54-.372h-.168c-.402 0-.684.377-.534.722.342.772 1.14 1.228 2.04 1.405v.373c0 .46.402.833.9.833s.9-.372.9-.833v-.361c1.17-.206 2.1-.834 2.1-1.973 0-1.577-1.458-2.116-2.82-2.444Z"
  })), cashback_path2 || (cashback_path2 = /*#__PURE__*/react.createElement("path", {
    className: "cashback_svg__stroke",
    d: "M21 12A9 9 0 0 0 5.636 5.636M3 12a9 9 0 0 0 16.484 5M21 4v8M3 12v8"
  })));
};
/* harmony default export */ var cashback = (SvgCashback);
;// CONCATENATED MODULE: ./src/svgs/logout.svg
var logout_path, logout_path2;
function logout_extends() { logout_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logout_extends.apply(this, arguments); }

var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/react.createElement("svg", logout_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), logout_path || (logout_path = /*#__PURE__*/react.createElement("path", {
    d: "M5 5h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c.55 0 1-.45 1-1s-.45-1-1-1H5V5Z",
    fill: "#fff"
  })), logout_path2 || (logout_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m20.65 11.65-2.79-2.79a.501.501 0 0 0-.86.35V11h-7c-.55 0-1 .45-1 1s.45 1 1 1h7v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var logout = (SvgLogout);
;// CONCATENATED MODULE: ./src/svgs/eye.svg
var eye_path, eye_path2;
function eye_extends() { eye_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_extends.apply(this, arguments); }

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/react.createElement("svg", eye_extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), eye_path || (eye_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 13.608A3.61 3.61 0 0 1 6.392 10 3.61 3.61 0 0 1 10 6.392 3.61 3.61 0 0 1 13.608 10 3.61 3.61 0 0 1 10 13.608Zm0-5.966A2.362 2.362 0 0 0 7.642 10c0 1.3 1.058 2.358 2.358 2.358S12.358 11.3 12.358 10 11.3 7.642 10 7.642Z"
  })), eye_path2 || (eye_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10 17.517c-3.133 0-6.091-1.834-8.125-5.017-.883-1.375-.883-3.617 0-5 2.042-3.183 5-5.017 8.125-5.017s6.084 1.834 8.117 5.017c.883 1.375.883 3.617 0 5-2.033 3.183-4.992 5.017-8.117 5.017Zm0-13.784c-2.691 0-5.266 1.617-7.066 4.442-.625.975-.625 2.675 0 3.65 1.8 2.825 4.375 4.442 7.066 4.442 2.692 0 5.267-1.617 7.067-4.442.625-.975.625-2.675 0-3.65-1.8-2.825-4.375-4.442-7.067-4.442Z"
  })));
};
/* harmony default export */ var eye = (SvgEye);
;// CONCATENATED MODULE: ./src/svgs/eye_reveal.svg
var eye_reveal_path, eye_reveal_path2, eye_reveal_g, eye_reveal_path3, _g2, eye_reveal_path4, _g3;
function eye_reveal_extends() { eye_reveal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_reveal_extends.apply(this, arguments); }

var SvgEyeReveal = function SvgEyeReveal(props) {
  return /*#__PURE__*/react.createElement("svg", eye_reveal_extends({
    width: 18,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), eye_reveal_path || (eye_reveal_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.134 10.118a.62.62 0 0 1-.442-.183A3.271 3.271 0 0 1 9 4.356c.866 0 1.706.35 2.305.961a.627.627 0 0 1-.89.88A1.987 1.987 0 0 0 9 5.609a2.018 2.018 0 0 0-1.424 3.44.628.628 0 0 1-.442 1.07ZM9.473 10.849a.626.626 0 0 1-.111-1.244 2.01 2.01 0 0 0 1.61-1.618.628.628 0 0 1 .726-.506c.34.061.566.387.505.728a3.27 3.27 0 0 1-2.618 2.63.645.645 0 0 1-.112.01Z"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "eye_reveal_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 13
  }, eye_reveal_path2 || (eye_reveal_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667.933h13.405v11.78H.667V.933Z",
    fill: "#fff"
  }))), eye_reveal_g || (eye_reveal_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#eye_reveal_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.545 12.713a.628.628 0 0 1-.385-.133C2.75 11.47 1.56 9.843.718 7.876a.625.625 0 0 1 0-.496c.85-1.975 2.049-3.61 3.466-4.727 2.888-2.293 6.733-2.3 9.65.016a.625.625 0 1 1-.776.983c-2.471-1.962-5.655-1.955-8.1-.015-1.197.944-2.224 2.32-2.983 3.992.751 1.663 1.77 3.03 2.957 3.965a.628.628 0 0 1-.387 1.12Z"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "eye_reveal_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 12,
    height: 11
  }, eye_reveal_path3 || (eye_reveal_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.265 4.373h11.068v9.984H6.265V4.373Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#eye_reveal_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.357a7.29 7.29 0 0 1-2.307-.377.628.628 0 0 1 .395-1.19A6.022 6.022 0 0 0 9 13.103c2.857 0 5.468-2.04 7.025-5.475a12.124 12.124 0 0 0-1.317-2.252.625.625 0 1 1 .998-.754 13.497 13.497 0 0 1 1.576 2.757c.069.158.069.339 0 .497-1.747 4.058-4.843 6.48-8.282 6.48Z"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "eye_reveal_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 15
  }, eye_reveal_path4 || (eye_reveal_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.803.411h14.395v14.434H1.803V.41Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#eye_reveal_svg__c)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.428 14.845a.627.627 0 0 1-.442-1.07L15.131.595a.623.623 0 0 1 .883 0 .628.628 0 0 1 0 .886L2.87 14.66a.619.619 0 0 1-.441.184Z"
  }))));
};
/* harmony default export */ var eye_reveal = (SvgEyeReveal);
;// CONCATENATED MODULE: ./src/svgs/password.svg
var password_g;
function password_extends() { password_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return password_extends.apply(this, arguments); }

var SvgPassword = function SvgPassword(props) {
  return /*#__PURE__*/react.createElement("svg", password_extends({
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), password_g || (password_g = /*#__PURE__*/react.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M14.516 8.5a.625.625 0 0 1-.625-.625V6.086a3.171 3.171 0 0 0-3.167-3.168h-.014c-.844 0-1.634.325-2.232.918a3.14 3.14 0 0 0-.937 2.236v1.803a.625.625 0 0 1-1.25 0V6.086c.005-1.2.469-2.308 1.306-3.138.839-.83 1.945-1.311 3.13-1.28a4.422 4.422 0 0 1 4.414 4.418v1.79c0 .344-.28.624-.625.624Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7.532 8.44a2.537 2.537 0 0 0-2.535 2.535v3.575a2.537 2.537 0 0 0 2.535 2.535H13.9a2.538 2.538 0 0 0 2.535-2.535v-3.575A2.538 2.538 0 0 0 13.9 8.44H7.532Zm6.368 9.895H7.532a3.789 3.789 0 0 1-3.785-3.785v-3.575A3.789 3.789 0 0 1 7.532 7.19H13.9a3.789 3.789 0 0 1 3.785 3.785v3.575a3.789 3.789 0 0 1-3.785 3.785Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M10.716 14.313a.625.625 0 0 1-.625-.625v-1.851a.625.625 0 0 1 1.25 0v1.85c0 .346-.28.626-.625.626Z"
  }))));
};
/* harmony default export */ var svgs_password = (SvgPassword);
;// CONCATENATED MODULE: ./src/svgs/warning.svg
var warning_path;
function warning_extends() { warning_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return warning_extends.apply(this, arguments); }

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/react.createElement("svg", warning_extends({
    viewBox: "0 0 24 24"
  }, props), warning_path || (warning_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
  })));
};
/* harmony default export */ var warning = (SvgWarning);
;// CONCATENATED MODULE: ./src/svgs/info.svg
var info_path;
function info_extends() { info_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return info_extends.apply(this, arguments); }

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/react.createElement("svg", info_extends({
    viewBox: "0 0 24 24"
  }, props), info_path || (info_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  })));
};
/* harmony default export */ var info = (SvgInfo);
;// CONCATENATED MODULE: ./src/svgs/success.svg
var success_path;
function success_extends() { success_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return success_extends.apply(this, arguments); }

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/react.createElement("svg", success_extends({
    viewBox: "0 0 24 24"
  }, props), success_path || (success_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  })));
};
/* harmony default export */ var success = (SvgSuccess);
;// CONCATENATED MODULE: ./src/svgs/wallet.svg
var wallet_path, wallet_path2;
function wallet_extends() { wallet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wallet_extends.apply(this, arguments); }

var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/react.createElement("svg", wallet_extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), wallet_path || (wallet_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.26 21.247a3.897 3.897 0 0 0 1.115-2.327 3.865 3.865 0 0 0-1.115-3.18 3.817 3.817 0 0 0-1.817-1.019 3.864 3.864 0 0 0-3.69 1.019 3.802 3.802 0 0 0-1.121 2.499c-.035.392 0 .798.103 1.19.158.668.502 1.301 1.019 1.818a3.893 3.893 0 0 0 5.506 0Zm-1.294-3.47c.4 0 .73.33.73.73a.746.746 0 0 1-.737.737l-.722-.007.007.695a.746.746 0 0 1-.737.737.746.746 0 0 1-.736-.737l.006-.695-.722.007a.746.746 0 0 1-.737-.737.754.754 0 0 1 .73-.73h.73v-.757c0-.206.082-.385.213-.516.13-.13.31-.213.516-.213.4 0 .73.33.73.73v.756h.73ZM15.096 3.846v3.699h-1.46v-3.7c0-.262-.233-.388-.39-.388a.39.39 0 0 0-.145.029l-7.72 2.91a1.308 1.308 0 0 0-.847 1.237v.652a3.636 3.636 0 0 0-1.46 2.92V7.633c0-1.159.71-2.19 1.791-2.6l7.73-2.92a1.855 1.855 0 0 1 2.502 1.733ZM21.571 14.117v.973a.486.486 0 0 1-.477.487h-1.42c-.517 0-.984-.38-1.023-.886a.972.972 0 0 1 .282-.779.925.925 0 0 1 .682-.282h1.47c.282.01.486.224.486.486Z",
    fill: "#E960AF"
  })), wallet_path2 || (wallet_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.603 12.606h.993a.976.976 0 0 0 .974-.973v-.429a3.668 3.668 0 0 0-3.66-3.66H6.734c-.827 0-1.586.273-2.2.74a3.636 3.636 0 0 0-1.46 2.92v1.733c0 .37.39.604.74.487a5.283 5.283 0 0 1 1.694-.282 5.363 5.363 0 0 1 5.354 5.354c0 .7-.185 1.47-.477 2.15-.156.351.087.77.467.77h7.058a3.668 3.668 0 0 0 3.66-3.66v-.185a.976.976 0 0 0-.974-.974h-.847c-.934 0-1.83-.574-2.073-1.48a1.96 1.96 0 0 1 .526-1.927 1.94 1.94 0 0 1 1.401-.584Zm-5.334-.195H9.402c-.4 0-.73-.33-.73-.73 0-.399.33-.73.73-.73h4.867c.399 0 .73.331.73.73 0 .4-.331.73-.73.73Z",
    fill: "#E960AF"
  })));
};
/* harmony default export */ var wallet = (SvgWallet);
;// CONCATENATED MODULE: ./src/svgs/open-page-icon.svg
var open_page_icon_path;
function open_page_icon_extends() { open_page_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return open_page_icon_extends.apply(this, arguments); }

var SvgOpenPageIcon = function SvgOpenPageIcon(props) {
  return /*#__PURE__*/react.createElement("svg", open_page_icon_extends({
    width: 12,
    height: 12,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), open_page_icon_path || (open_page_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M15 16H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H2a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1ZM11 1c0 .55.45 1 1 1h2.59l-9.13 9.13a.996.996 0 1 0 1.41 1.41L16 3.41V6c0 .55.45 1 1 1s1-.45 1-1V0h-6c-.55 0-1 .45-1 1Z",
    fill: "#F3C622"
  })));
};
/* harmony default export */ var open_page_icon = (SvgOpenPageIcon);
;// CONCATENATED MODULE: ./src/svgs/hourglass.svg
var hourglass_path;
function hourglass_extends() { hourglass_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hourglass_extends.apply(this, arguments); }

var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/react.createElement("svg", hourglass_extends({
    viewBox: "0 0 24 24"
  }, props), hourglass_path || (hourglass_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 2c-1.1 0-2 .9-2 2l.01 3.18c0 .53.21 1.03.58 1.41L10 12l-3.41 3.43c-.37.37-.58.88-.58 1.41L6 20c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-3.16c0-.53-.21-1.04-.58-1.41L14 12l3.41-3.4c.38-.38.59-.89.59-1.42V4c0-1.1-.9-2-2-2H8zm8 14.91V19c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-2.09c0-.27.11-.52.29-.71L12 12.5l3.71 3.71c.18.18.29.44.29.7z"
  })));
};
/* harmony default export */ var hourglass = (SvgHourglass);
;// CONCATENATED MODULE: ./src/svgs/success-check.svg
var success_check_path;
function success_check_extends() { success_check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return success_check_extends.apply(this, arguments); }

var SvgSuccessCheck = function SvgSuccessCheck(props) {
  return /*#__PURE__*/react.createElement("svg", success_check_extends({
    viewBox: "0 0 24 24"
  }, props), success_check_path || (success_check_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 16.17 5.53 12.7a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71a.996.996 0 0 0 0-1.41.996.996 0 0 0-1.41 0L9 16.17z"
  })));
};
/* harmony default export */ var success_check = (SvgSuccessCheck);
;// CONCATENATED MODULE: ./src/svgs/add-icon.svg
var add_icon_path;
function add_icon_extends() { add_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return add_icon_extends.apply(this, arguments); }

var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/react.createElement("svg", add_icon_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), add_icon_path || (add_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.857 9.143H9.143v5.714C9.143 15.486 8.629 16 8 16a1.146 1.146 0 0 1-1.143-1.143V9.143H1.143A1.146 1.146 0 0 1 0 8c0-.629.514-1.143 1.143-1.143h5.714V1.143C6.857.514 7.371 0 8 0s1.143.514 1.143 1.143v5.714h5.714C15.486 6.857 16 7.371 16 8s-.514 1.143-1.143 1.143Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var add_icon = (SvgAddIcon);
;// CONCATENATED MODULE: ./src/svgs/edit-icon.svg
var edit_icon_path;
function edit_icon_extends() { edit_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return edit_icon_extends.apply(this, arguments); }

var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/react.createElement("svg", edit_icon_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), edit_icon_path || (edit_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 16.854v2.702a.44.44 0 0 0 .444.444h2.702a.417.417 0 0 0 .311-.133l9.706-9.697-3.333-3.333-9.697 9.697a.436.436 0 0 0-.133.32Zm15.74-9.261a.885.885 0 0 0 0-1.253l-2.08-2.08a.885.885 0 0 0-1.253 0l-1.626 1.626 3.333 3.333 1.626-1.626Z",
    fill: "#A8A9AC"
  })));
};
/* harmony default export */ var edit_icon = (SvgEditIcon);
;// CONCATENATED MODULE: ./src/svgs/date-range-icon.svg
var date_range_icon_path;
function date_range_icon_extends() { date_range_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return date_range_icon_extends.apply(this, arguments); }

var SvgDateRangeIcon = function SvgDateRangeIcon(props) {
  return /*#__PURE__*/react.createElement("svg", date_range_icon_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), date_range_icon_path || (date_range_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V9h14v10ZM7 11h2v2H7v-2Zm4 0h2v2h-2v-2Zm4 0h2v2h-2v-2Z",
    fill: "#A8A9AC"
  })));
};
/* harmony default export */ var date_range_icon = (SvgDateRangeIcon);
;// CONCATENATED MODULE: ./src/svgs/trash-bin-icon.svg
var trash_bin_icon_path;
function trash_bin_icon_extends() { trash_bin_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trash_bin_icon_extends.apply(this, arguments); }

var SvgTrashBinIcon = function SvgTrashBinIcon(props) {
  return /*#__PURE__*/react.createElement("svg", trash_bin_icon_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), trash_bin_icon_path || (trash_bin_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10ZM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var trash_bin_icon = (SvgTrashBinIcon);
;// CONCATENATED MODULE: ./src/svgs/verify.svg
var verify_path;
function verify_extends() { verify_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return verify_extends.apply(this, arguments); }

var SvgVerify = function SvgVerify(props) {
  return /*#__PURE__*/react.createElement("svg", verify_extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), verify_path || (verify_path = /*#__PURE__*/react.createElement("path", {
    d: "m17.967 9.45-1.134-1.317a1.847 1.847 0 0 1-.391-1.05V5.667c0-.884-.725-1.609-1.609-1.609h-1.416c-.325 0-.8-.175-1.05-.391L11.05 2.533c-.575-.491-1.517-.491-2.1 0L7.642 3.675c-.25.208-.725.383-1.05.383H5.15c-.883 0-1.608.725-1.608 1.609v1.425c0 .325-.175.791-.384 1.041L2.033 9.458c-.483.575-.483 1.509 0 2.084l1.125 1.325c.209.25.384.716.384 1.041v1.425c0 .884.725 1.609 1.608 1.609h1.442c.325 0 .8.175 1.05.391l1.316 1.134c.575.491 1.517.491 2.1 0l1.317-1.134c.25-.216.717-.391 1.05-.391h1.417c.883 0 1.608-.725 1.608-1.609v-1.416c0-.325.175-.8.392-1.05l1.133-1.317c.483-.575.483-1.525-.008-2.1Zm-4.5-.525L9.442 12.95a.624.624 0 0 1-.884 0l-2.016-2.017a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0L9 11.625l3.583-3.583a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .883Z",
    fill: "#06C270"
  })));
};
/* harmony default export */ var verify = (SvgVerify);
;// CONCATENATED MODULE: ./src/svgs/bin.svg
var bin_path, bin_path2, bin_path3;
function bin_extends() { bin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bin_extends.apply(this, arguments); }

var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/react.createElement("svg", bin_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), bin_path || (bin_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.5 5.608h-.068C13.024 5.167 8.624 5 4.266 5.442l-1.7.166a.63.63 0 0 1-.134-1.25l1.7-.166c4.434-.45 8.925-.275 13.425.166a.626.626 0 0 1 .559.684.617.617 0 0 1-.617.566Z"
  })), bin_path2 || (bin_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.083 4.767c-.034 0-.067 0-.109-.009a.627.627 0 0 1-.508-.716l.183-1.092c.134-.8.317-1.908 2.259-1.908h2.183c1.95 0 2.133 1.15 2.258 1.916l.184 1.084a.619.619 0 0 1-.509.716.619.619 0 0 1-.716-.508l-.184-1.083c-.116-.725-.141-.867-1.025-.867H8.916c-.883 0-.9.117-1.025.858l-.192 1.084a.625.625 0 0 1-.616.525ZM12.676 18.958h-5.35c-2.908 0-3.025-1.608-3.117-2.908l-.541-8.392a.63.63 0 0 1 .583-.666.631.631 0 0 1 .667.583l.541 8.392c.092 1.266.125 1.741 1.867 1.741h5.35c1.75 0 1.783-.475 1.867-1.741l.541-8.392a.637.637 0 0 1 .667-.583.626.626 0 0 1 .583.666l-.541 8.392c-.092 1.3-.209 2.908-3.117 2.908Z"
  })), bin_path3 || (bin_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M11.382 14.375H8.607a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h2.775a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625ZM12.083 11.042H7.916a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.167a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
  })));
};
/* harmony default export */ var bin = (SvgBin);
;// CONCATENATED MODULE: ./src/svgs/provider-filter.svg
var provider_filter_path;
function provider_filter_extends() { provider_filter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return provider_filter_extends.apply(this, arguments); }

var SvgProviderFilter = function SvgProviderFilter(props) {
  return /*#__PURE__*/react.createElement("svg", provider_filter_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), provider_filter_path || (provider_filter_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.398 5.315c0 1.556-1.282 2.817-2.866 2.817-1.582 0-2.865-1.261-2.865-2.817C1.667 3.761 2.95 2.5 4.532 2.5c1.584 0 2.866 1.26 2.866 2.815Zm9.68-1.233c.692 0 1.255.553 1.255 1.233 0 .682-.563 1.235-1.255 1.235h-5.48a1.246 1.246 0 0 1-1.257-1.235c0-.68.564-1.233 1.257-1.233h5.48ZM2.923 13.298h5.48c.693 0 1.256.553 1.256 1.235 0 .68-.563 1.234-1.256 1.234h-5.48a1.247 1.247 0 0 1-1.256-1.234c0-.682.562-1.235 1.256-1.235Zm12.544 4.017c1.584 0 2.866-1.261 2.866-2.816s-1.282-2.816-2.866-2.816c-1.582 0-2.865 1.26-2.865 2.816 0 1.555 1.283 2.816 2.865 2.816Z",
    fill: "#ADADAD"
  })));
};
/* harmony default export */ var provider_filter = (SvgProviderFilter);
;// CONCATENATED MODULE: ./src/svgs/help-outline.svg
var help_outline_path;
function help_outline_extends() { help_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return help_outline_extends.apply(this, arguments); }

var SvgHelpOutline = function SvgHelpOutline(props) {
  return /*#__PURE__*/react.createElement("svg", help_outline_extends({
    className: "help-outline_svg__svg-icon",
    width: 20,
    height: 20,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), help_outline_path || (help_outline_path = /*#__PURE__*/react.createElement("path", {
    d: "M469.333 768h85.334v-85.333h-85.334V768zM512 85.333C276.48 85.333 85.333 276.48 85.333 512S276.48 938.667 512 938.667 938.667 747.52 938.667 512 747.52 85.333 512 85.333zm0 768c-188.16 0-341.333-153.173-341.333-341.333S323.84 170.667 512 170.667 853.333 323.84 853.333 512 700.16 853.333 512 853.333zM512 256c-94.293 0-170.667 76.373-170.667 170.667h85.334c0-46.934 38.4-85.334 85.333-85.334s85.333 38.4 85.333 85.334c0 85.333-128 74.666-128 213.333h85.334c0-96 128-106.667 128-213.333C682.667 332.373 606.293 256 512 256z"
  })));
};
/* harmony default export */ var help_outline = (SvgHelpOutline);
;// CONCATENATED MODULE: ./src/svgs/circle-loading-background.svg
var circle_loading_background_path, circle_loading_background_defs;
function circle_loading_background_extends() { circle_loading_background_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_loading_background_extends.apply(this, arguments); }

var SvgCircleLoadingBackground = function SvgCircleLoadingBackground(props) {
  return /*#__PURE__*/react.createElement("svg", circle_loading_background_extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), circle_loading_background_path || (circle_loading_background_path = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    d: "M16.5 8.286a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-13.758 0a5.758 5.758 0 1 0 11.516 0 5.758 5.758 0 0 0-11.516 0Z",
    fill: "url(#circle-loading-background_svg__a)"
  })), circle_loading_background_defs || (circle_loading_background_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "circle-loading-background_svg__a",
    x1: 24.649,
    y1: 49.195,
    x2: -1.959,
    y2: 48.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F3C622"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.846,
    stopColor: "#F953C6"
  })))));
};
/* harmony default export */ var circle_loading_background = (SvgCircleLoadingBackground);
;// CONCATENATED MODULE: ./src/svgs/circle-loading.svg
var circle_loading_path, circle_loading_defs;
function circle_loading_extends() { circle_loading_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_loading_extends.apply(this, arguments); }

var SvgCircleLoading = function SvgCircleLoading(props) {
  return /*#__PURE__*/react.createElement("svg", circle_loading_extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), circle_loading_path || (circle_loading_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 1.12C8 .503 7.496-.007 6.883.079a8 8 0 1 0 9.113 8.173c.02-.619-.542-1.064-1.158-.997-.615.067-1.048.624-1.101 1.24a5.76 5.76 0 1 1-6.85-6.143C7.493 2.23 8 1.74 8 1.12Z",
    fill: "url(#circle-loading_svg__a)"
  })), circle_loading_defs || (circle_loading_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "circle-loading_svg__a",
    x1: 24.149,
    y1: 48.909,
    x2: -2.459,
    y2: 48.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#F3C622"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.846,
    stopColor: "#F953C6"
  })))));
};
/* harmony default export */ var circle_loading = (SvgCircleLoading);
;// CONCATENATED MODULE: ./src/svgs/telegram.svg
var telegram_path;
function telegram_extends() { telegram_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return telegram_extends.apply(this, arguments); }

var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/react.createElement("svg", telegram_extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), telegram_path || (telegram_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.349 2.667C8.983 2.667 3.016 8.635 3.016 16c0 7.366 5.967 13.334 13.333 13.334 7.366 0 13.333-5.968 13.333-13.334 0-7.365-5.967-13.333-13.333-13.333Zm6.548 9.134L20.71 22.113c-.161.731-.597.909-1.204.565l-3.333-2.457-1.608 1.548c-.177.178-.328.328-.672.328l.237-3.392 6.177-5.581c.269-.237-.06-.371-.414-.134l-7.634 4.806-3.29-1.027c-.716-.226-.732-.715.15-1.059l12.855-4.957c.596-.215 1.118.145.924 1.048Z",
    fill: "#E0E0E0"
  })));
};
/* harmony default export */ var telegram = (SvgTelegram);
;// CONCATENATED MODULE: ./src/svgs/twitter.svg
var twitter_path;
function twitter_extends() { twitter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), twitter_path || (twitter_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.349 2.667C8.985 2.667 3.016 8.637 3.016 16c0 7.364 5.97 13.334 13.333 13.334 7.364 0 13.333-5.97 13.333-13.334S23.712 2.667 16.35 2.667Zm5.424 10.922c.005.114.006.228.006.34 0 3.471-2.64 7.473-7.47 7.473a7.41 7.41 0 0 1-4.025-1.18c.204.024.414.034.626.034a5.26 5.26 0 0 0 3.261-1.124 2.632 2.632 0 0 1-2.453-1.822c.394.075.799.06 1.185-.046a2.627 2.627 0 0 1-2.107-2.575v-.032c.354.196.76.316 1.19.33a2.625 2.625 0 0 1-.812-3.509 7.467 7.467 0 0 0 5.413 2.746 2.625 2.625 0 0 1 4.474-2.396 5.275 5.275 0 0 0 1.667-.637 2.64 2.64 0 0 1-1.154 1.454 5.277 5.277 0 0 0 1.508-.415 5.326 5.326 0 0 1-1.31 1.36Z",
    fill: "#E0E0E0"
  })));
};
/* harmony default export */ var twitter = (SvgTwitter);
;// CONCATENATED MODULE: ./src/svgs/medium.svg
var medium_path;
function medium_extends() { medium_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return medium_extends.apply(this, arguments); }

var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/react.createElement("svg", medium_extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), medium_path || (medium_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.349 2.667C8.986 2.667 3.016 8.637 3.016 16s5.97 13.334 13.333 13.334S29.682 23.364 29.682 16c0-7.363-5.97-13.333-13.333-13.333Zm7.619 7.55-1.214 1.164a.353.353 0 0 0-.137.34v8.562c-.021.131.03.262.137.34l1.19 1.163v.259h-5.976v-.247l1.23-1.193c.121-.122.121-.158.121-.34v-6.928l-3.422 8.678h-.462l-3.982-8.678v5.818a.793.793 0 0 0 .223.667l1.601 1.937v.26H8.73v-.26l1.601-1.937a.777.777 0 0 0 .208-.667V12.43a.577.577 0 0 0-.193-.497l-1.423-1.714v-.26h4.42l3.41 7.486 3.004-7.48h4.211v.254Z",
    fill: "#E0E0E0"
  })));
};
/* harmony default export */ var medium = (SvgMedium);
;// CONCATENATED MODULE: ./src/svgs/discord.svg
var discord_path, discord_path2;
function discord_extends() { discord_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return discord_extends.apply(this, arguments); }

var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/react.createElement("svg", discord_extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), discord_path || (discord_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.805 18.337c.2.253.44.54.44.54 1.476-.046 2.043-1.014 2.043-1.014 0-2.15-.96-3.892-.96-3.892-.962-.72-1.877-.7-1.877-.7l-.093.106c1.135.347 1.662.848 1.662.848a5.444 5.444 0 0 0-3.357-.628c-.036 0-.065.005-.099.011l-.015.003c-.234.02-.801.106-1.515.42a7.04 7.04 0 0 0-.394.194s.554-.527 1.755-.875l-.066-.08s-.915-.02-1.876.701c0 0-.961 1.742-.961 3.892 0 0 .56.968 2.036 1.014 0 0 .247-.3.447-.554-.848-.253-1.168-.787-1.168-.787s.067.046.187.113c.006.007.013.014.026.02.01.007.02.012.03.017a3.912 3.912 0 0 0 .517.244c.274.106.601.213.982.287.5.093 1.088.126 1.729.006.314-.053.634-.147.968-.287.233-.087.494-.213.767-.394 0 0-.333.548-1.208.795ZM14.461 16.5c0-.407.3-.74.68-.74.381 0 .688.333.682.74 0 .407-.3.74-.681.74-.374 0-.681-.333-.681-.74Zm2.436 0c0-.407.3-.74.681-.74.38 0 .681.333.681.74s-.3.74-.68.74c-.375 0-.682-.333-.682-.74Z",
    fill: "#E0E0E0"
  })), discord_path2 || (discord_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.35 2.65C23.723 2.65 29.7 8.627 29.7 16c0 7.373-5.977 13.35-13.35 13.35C8.977 29.35 3 23.373 3 16 3 8.627 8.977 2.65 16.35 2.65Zm-5.84 8.885c0-.761.614-1.375 1.368-1.375h8.944c.755 0 1.369.614 1.369 1.375V23.51l-1.435-1.269-.808-.747-.855-.794.354 1.235h-7.57a1.372 1.372 0 0 1-1.368-1.376v-9.024Z",
    fill: "#E0E0E0"
  })));
};
/* harmony default export */ var discord = (SvgDiscord);
;// CONCATENATED MODULE: ./src/svgs/icon-deposit.svg
var icon_deposit_path;
function icon_deposit_extends() { icon_deposit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_deposit_extends.apply(this, arguments); }

var SvgIconDeposit = function SvgIconDeposit(props) {
  return /*#__PURE__*/react.createElement("svg", icon_deposit_extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_deposit_path || (icon_deposit_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.997 16.253a1.787 1.787 0 0 1-.997-1.61 5.14 5.14 0 0 0-2.94-4.634l-1.466-.697h1.594a.313.313 0 1 0 0-.624h-.625l.5-.376a.312.312 0 1 0-.375-.5l-.938.694-.237.178h-.044l.59-.787-.084-.063c-.081-.065-.11-.087-.194-.087a.26.26 0 0 0-.196.087.875.875 0 0 1-1.172 0c-.082-.065-.11-.087-.194-.087s-.113.022-.197.087l-.081.063.59.79h-.187a.181.181 0 0 0-.06 0 .222.222 0 0 0-.062 0 .313.313 0 0 0-.16.313.215.215 0 0 0 0 .078c.01.04.027.077.05.11h.016a.178.178 0 0 0 .041.043.472.472 0 0 0 .122.056.284.284 0 0 0 .084.025h.05l-1.475.691A5.145 5.145 0 0 0 5 14.643a1.787 1.787 0 0 1-.997 1.61.46.46 0 0 0 .207.872h11.58a.46.46 0 0 0 .207-.872Zm-6.231-2.878h.469a.982.982 0 0 1 1.015.938.972.972 0 0 1-.937.937v.313a.313.313 0 1 1-.625 0v-.313h-.625a.312.312 0 1 1 0-.625h1.172a.313.313 0 1 0 0-.625h-.47a.981.981 0 0 1-1.015-.938.972.972 0 0 1 .938-.937v-.313a.313.313 0 1 1 .625 0v.313h.625a.313.313 0 1 1 0 .625H9.766a.313.313 0 1 0 0 .625Zm-1.64-8.438h1.562v2.329c.043.028.081.059.115.084a.26.26 0 0 0 .197.088c.085 0 .113-.022.194-.088a.979.979 0 0 1 .119-.087V4h1.562A3.438 3.438 0 0 0 15.313.562.312.312 0 0 0 15 .25h-1.875A3.437 3.437 0 0 0 9.8 2.819a3.437 3.437 0 0 0-2.925-1.631H5a.312.312 0 0 0-.312.312 3.437 3.437 0 0 0 3.437 3.438Z"
  })));
};
/* harmony default export */ var icon_deposit = (SvgIconDeposit);
;// CONCATENATED MODULE: ./src/svgs/icon-withdraw.svg
var icon_withdraw_g, icon_withdraw_defs;
function icon_withdraw_extends() { icon_withdraw_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_withdraw_extends.apply(this, arguments); }

var SvgIconWithdraw = function SvgIconWithdraw(props) {
  return /*#__PURE__*/react.createElement("svg", icon_withdraw_extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_withdraw_g || (icon_withdraw_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#icon-withdraw_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M10 13.312a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.25 3.936H3.75a.625.625 0 0 0-.625.625v13.213a2.413 2.413 0 0 0 2.412 2.412h8.925a2.413 2.413 0 0 0 2.413-2.412V4.561a.625.625 0 0 0-.625-.625ZM10 14.562a3.75 3.75 0 1 1 0-7.501 3.75 3.75 0 0 1 0 7.5Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17.5 1.436h-15A1.875 1.875 0 0 0 .625 3.311v3.75a1.875 1.875 0 0 0 1.25 1.763V4.561A1.875 1.875 0 0 1 3.75 2.686h12.5a1.875 1.875 0 0 1 1.875 1.875v4.263a1.875 1.875 0 0 0 1.25-1.763v-3.75A1.875 1.875 0 0 0 17.5 1.436Z"
  }))), icon_withdraw_defs || (icon_withdraw_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "icon-withdraw_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    transform: "translate(0 .811)",
    d: "M0 0h20v20H0z"
  })))));
};
/* harmony default export */ var icon_withdraw = (SvgIconWithdraw);
;// CONCATENATED MODULE: ./src/svgs/icon-swap.svg
var icon_swap_path, icon_swap_path2, icon_swap_path3, icon_swap_path4;
function icon_swap_extends() { icon_swap_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_swap_extends.apply(this, arguments); }

var SvgIconSwap = function SvgIconSwap(props) {
  return /*#__PURE__*/react.createElement("svg", icon_swap_extends({
    width: 20,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), icon_swap_path || (icon_swap_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.543 14.136a.464.464 0 0 0 .26-.17.498.498 0 0 0 .088-.298.547.547 0 0 0-.083-.306.415.415 0 0 0-.23-.173 2.078 2.078 0 0 0-.54-.05H5.32v1.039h.755c.157.006.314-.008.467-.042Z"
  })), icon_swap_path2 || (icon_swap_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M5.868 9.596a4.906 4.906 0 1 0 4.906 4.906 4.932 4.932 0 0 0-4.906-4.906Zm1.68 6.216a.985.985 0 0 1-.287.377 1.27 1.27 0 0 1-.427.192 1.95 1.95 0 0 1-.377.05v.512h-.495v-.509h-.264v.498h-.494v-.498H4.74v-3.826h.464v-.498h.494v.498h.264v-.498h.491v.52c.148.01.295.042.434.095a.94.94 0 0 1 .426.377.981.981 0 0 1 .155.517.89.89 0 0 1-.136.476.935.935 0 0 1-.32.309.944.944 0 0 1 .637.913c.004.17-.031.34-.102.495Z"
  })), icon_swap_path3 || (icon_swap_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M6.672 14.774a1.743 1.743 0 0 0-.532-.06h-.82v1.192h.888c.11.002.22-.004.328-.02a.755.755 0 0 0 .268-.093.457.457 0 0 0 .173-.193.6.6 0 0 0 .068-.29.608.608 0 0 0-.098-.34.532.532 0 0 0-.275-.196Zm8.064-6.366a3.191 3.191 0 0 0-.332-.102v1.26c.117-.009.233-.034.343-.075a.72.72 0 0 0 .332-.234.555.555 0 0 0 .106-.321.49.49 0 0 0-.102-.306.777.777 0 0 0-.347-.222ZM13.238 7a.421.421 0 0 0 .143.325c.148.095.312.162.483.2V6.472a.842.842 0 0 0-.419.15.486.486 0 0 0-.207.378Z"
  })), icon_swap_path4 || (icon_swap_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M14.132 3.076a4.906 4.906 0 1 0 4.906 4.905 4.928 4.928 0 0 0-4.906-4.905Zm1.464 6.434a1.231 1.231 0 0 1-.547.464 1.824 1.824 0 0 1-.645.147v.581h-.54v-.585a1.888 1.888 0 0 1-.555-.132 1.35 1.35 0 0 1-.603-.494 1.418 1.418 0 0 1-.23-.755v-.042l.592-.052v.045c.015.17.07.332.162.475a.834.834 0 0 0 .377.299c.08.035.161.061.246.079V8.17a3.138 3.138 0 0 1-.634-.215 1.155 1.155 0 0 1-.45-.378.989.989 0 0 1-.15-.528c.007-.22.08-.433.211-.611.13-.192.316-.34.532-.423.167-.066.342-.107.52-.12v-.59h.54v.593c.175.018.347.06.51.125.22.092.409.249.54.449.126.197.197.426.203.66v.045l-.603.046v-.046a.773.773 0 0 0-.264-.547.83.83 0 0 0-.378-.166v1.2c.228.051.452.12.668.208.218.088.406.236.543.426.118.18.178.39.174.604-.01.225-.086.441-.219.623V9.51ZM8.585 2.28a.377.377 0 1 0-.51.554l.604.547c-1.558 0-2.792.43-3.672 1.306-1.61 1.574-1.43 3.962-1.422 4.049a.377.377 0 0 0 .377.347h.03a.377.377 0 0 0 .348-.407c0-.02-.144-2.151 1.192-3.476.725-.717 1.766-1.075 3.094-1.075l-.754.649a.377.377 0 0 0-.02.566.377.377 0 0 0 .533.034l1.51-1.313a.377.377 0 0 0 .007-.563L8.585 2.28Zm9.207 10.856a.377.377 0 0 0-.377.355c0 .022-.132 2.143-1.634 3.287-.815.618-1.887.837-3.215.664l.819-.547a.379.379 0 0 0 .114-.545.378.378 0 0 0-.552-.067l-1.656 1.106a.377.377 0 0 0-.08.558l1.132 1.359a.377.377 0 0 0 .622-.066.377.377 0 0 0-.044-.417l-.513-.653c.323.049.65.074.977.075a4.562 4.562 0 0 0 2.841-.867c1.778-1.355 1.925-3.744 1.932-3.846a.376.376 0 0 0-.366-.396Z"
  })));
};
/* harmony default export */ var icon_swap = (SvgIconSwap);
;// CONCATENATED MODULE: ./src/svgs/wallet/metamask-fox.svg
function metamask_fox_extends() { metamask_fox_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return metamask_fox_extends.apply(this, arguments); }

var SvgMetamaskFox = function SvgMetamaskFox(props) {
  return /*#__PURE__*/react.createElement("svg", metamask_fox_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e17726",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e17726",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m32.959.999-13.135 9.719 2.442-5.727Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e27625",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e27625",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m2.661.999 13.018 9.81-2.325-5.818ZM28.228 23.535l-3.492 5.335 7.48 2.063 2.144-7.283ZM1.274 23.65l2.13 7.283 7.47-2.063-3.481-5.335Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e27625",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e27625",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M10.469 14.516 8.394 17.65l7.402.336-.244-7.97ZM25.151 14.516l-5.156-4.59-.17 8.061 7.406-.336ZM10.874 28.87l4.482-2.163L11.5 23.7ZM20.264 26.707l4.472 2.163-.61-5.17Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#d5bfb2",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#d5bfb2",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m24.736 28.87-4.472-2.163.366 2.905-.04 1.229ZM10.874 28.87l4.155 1.97-.024-1.228.351-2.905Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#233447",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#233447",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m15.107 21.785-3.715-1.09 2.627-1.203ZM20.513 21.785l1.089-2.293 2.641 1.202Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#cc6228",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#cc6228",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m10.874 28.87.65-5.335-4.131.115ZM24.097 23.535l.64 5.335 3.49-5.22ZM27.231 17.65l-7.407.337.689 3.798 1.089-2.293 2.641 1.202ZM11.392 20.694l2.627-1.202 1.088 2.293.689-3.798-7.402-.336Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#e27525",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#e27525",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m8.394 17.65 3.105 6.05-.107-3.006ZM24.243 20.694l-.117 3.006 3.105-6.05ZM15.796 17.987l-.689 3.798.87 4.484.195-5.911ZM19.824 17.987l-.366 2.357.186 5.925.869-4.484Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#f5841f",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#f5841f",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m20.513 21.785-.87 4.484.62.438 3.863-3.007.117-3.006ZM11.392 20.694l.107 3.006 3.857 3.007.62-.438-.869-4.484Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#c0ac9d",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#c0ac9d",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m20.59 30.84.04-1.228-.337-.286h-4.966l-.322.286.024 1.229-4.155-1.97 1.455 1.192 2.95 2.035h5.053l2.959-2.035 1.445-1.193Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#161616",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#161616",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m20.264 26.707-.62-.438h-3.667l-.62.438-.352 2.905.322-.286h4.966l.337.286Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#763e1a",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#763e1a",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m33.516 11.353 1.103-5.363L32.96.999l-12.695 9.396 4.887 4.12 6.9 2.008 1.518-1.777-.664-.479 1.055-.957-.806-.622 1.05-.806ZM1.001 5.99l1.118 5.363-.718.53 1.065.805-.806.622 1.055.957-.664.479 1.523 1.777 6.895-2.007 4.887-4.12L2.661.998Zm0 0",
    transform: "scale(.8 .84849)"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "#f5841f",
      fillOpacity: 1,
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#f5841f",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "m32.05 16.523-6.899-2.007 2.08 3.135-3.105 6.05 4.102-.051h6.132ZM10.469 14.516l-6.895 2.007-2.3 7.127h6.119l4.106.05-3.105-6.05ZM19.824 17.987l.44-7.592 2.002-5.404h-8.912l2.002 5.404.44 7.592.17 2.385.01 5.897h3.668l.01-5.897Zm0 0",
    transform: "scale(.8 .84849)"
  }));
};
/* harmony default export */ var metamask_fox = (SvgMetamaskFox);
;// CONCATENATED MODULE: ./src/svgs/wallet/bitkeep.svg
var _script, bitkeep_g, bitkeep_defs;
function bitkeep_extends() { bitkeep_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bitkeep_extends.apply(this, arguments); }

var SvgBitkeep = function SvgBitkeep(props) {
  return /*#__PURE__*/react.createElement("svg", bitkeep_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _script || (_script = /*#__PURE__*/react.createElement("script", {
    type: "text/javascript"
  })), bitkeep_g || (bitkeep_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#bitkeep_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M32 10.058c0-.293 0-.69-.006-1.175-.005-.511-.008-.719-.013-.96-.014-.72-.06-1.445-.182-2.095-.133-.707-.312-1.35-.639-1.993-.33-.653-.784-1.217-1.276-1.719-.503-.491-1.067-.944-1.718-1.275C27.523.515 26.88.335 26.172.2 25.523.08 24.797.034 24.078.02A135.21 135.21 0 0 0 21.941 0H10.059a135.208 135.208 0 0 0-2.136.02C7.203.033 6.478.079 5.828.2c-.707.133-1.35.312-1.993.639-.652.33-1.216.785-1.72 1.276-.49.503-.944 1.067-1.275 1.718C.514 4.477.334 5.12.2 5.828.08 6.477.033 7.203.02 7.922A135.208 135.208 0 0 0 0 10.059v11.883a135.21 135.21 0 0 0 .019 2.136c.014.719.06 1.444.182 2.094.133.707.312 1.35.639 1.993.33.653.784 1.217 1.276 1.719.503.491 1.067.944 1.718 1.275.643.326 1.286.506 1.994.64.649.121 1.375.168 2.094.182a123.546 123.546 0 0 0 2.136.019h11.884c.293 0 .69 0 1.175-.007.511-.005.719-.008.96-.012.72-.014 1.445-.06 2.095-.183.707-.133 1.35-.312 1.993-.639.653-.33 1.217-.784 1.719-1.275.491-.503.944-1.067 1.275-1.719.326-.643.506-1.286.64-1.993.121-.65.168-1.375.182-2.094A123.547 123.547 0 0 0 32 21.942V10.058Z",
    fill: "#7524F9"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.945 11.072v1.13a.62.62 0 0 1-.312.539l-3.641 2.103 3.253 1.873a1.399 1.399 0 0 1 .701 1.212v3.012a1.4 1.4 0 0 1-.702 1.213l-8.556 4.91a1.397 1.397 0 0 1-1.396-.002l-2.801-1.617a.31.31 0 0 1 0-.538l9.246-5.322a.155.155 0 0 0 .056-.213.155.155 0 0 0-.056-.057l-3.435-1.983a.621.621 0 0 0-.62 0l-9.396 5.412a.466.466 0 0 1-.464 0l-1.062-.609a1.4 1.4 0 0 1-.705-1.214v-1.233a.467.467 0 0 1 .235-.404l13.464-7.738a.156.156 0 0 0 0-.27l-3.438-1.99a.622.622 0 0 0-.621 0L6.52 14.564a.313.313 0 0 1-.466-.27v-3.235a1.399 1.399 0 0 1 .703-1.214l8.556-4.908a1.397 1.397 0 0 1 1.394.001l8.538 4.924a1.4 1.4 0 0 1 .7 1.211Z",
    fill: "#fff"
  }))), bitkeep_defs || (bitkeep_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "bitkeep_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
/* harmony default export */ var bitkeep = (SvgBitkeep);
;// CONCATENATED MODULE: ./src/svgs/wallet/math-wallet.svg
var math_wallet_defs, _use;
function math_wallet_extends() { math_wallet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return math_wallet_extends.apply(this, arguments); }

var SvgMathWallet = function SvgMathWallet(props) {
  return /*#__PURE__*/react.createElement("svg", math_wallet_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28
  }, props), math_wallet_defs || (math_wallet_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("image", {
    id: "math-wallet_svg__a",
    width: 29,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABmJLR0QA/wD/AP+gvaeTAAABKElEQVRIie2Pvy6DcRSGnw+xMDUdmYSkLHoLrDogUYuFy+AKpAb/YnYTGMxSkUjMDE1cAJVGoiqPwZE00aKNwfB7ki95z/e+5/fmQCKRSPSLWlT31XwHL68eqLN/XbrnBysdvHJ4u799b+CHshn1AqgCZWBSPVVH1FH1FJgI71K9UKd7O+lr6XJcsRnzmdpUx9Tx0CfhbUV2qe9L1UPgAZgCGuozsB2XLQILoXfCe4rsY+z2Xgq8Am9Zlt0CzfgaWZbdAy2gFbrx6Uf2LXZ/j1pS50Ln1Du1GPOGet6WPVfXQxcjm4t5Xi116hjq8O8qLgGoA0dALeYq8NKWPQauQ9ciW4/5psv73VEraqGLt6audvEKaqWnsrbl4W+8IXWwn91EIpH4X7wDfCzwwF2uPowAAAAASUVORK5CYII="
  }))), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14Zm0 0"
  }), _use || (_use = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#math-wallet_svg__a"
  })));
};
/* harmony default export */ var math_wallet = (SvgMathWallet);
;// CONCATENATED MODULE: ./src/svgs/wallet/safepal.svg
var safepal_circle, safepal_path;
function safepal_extends() { safepal_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return safepal_extends.apply(this, arguments); }

var SvgSafepal = function SvgSafepal(props) {
  return /*#__PURE__*/react.createElement("svg", safepal_extends({
    viewBox: "0 0 96 96",
    width: 32,
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    className: "safepal_svg__sc-bdnxRM safepal_svg__kDWlca"
  }, props), safepal_circle || (safepal_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F5F5F5"
  })), safepal_path || (safepal_path = /*#__PURE__*/react.createElement("path", {
    d: "M56.55 41.939v8.527h-9.155v35.131l-2.387-.89a79.857 79.857 0 0 1-5.103-2.115l-1.037-.474V14.682l9.089-2.805 8.593 2.65v9.199l-8.593-2.659-.562.174V41.94h9.155ZM16 50.466V21.774l20.17-6.226v9.157L24.526 28.32v13.619H36.17V81.38l-2.579-1.327C25.566 75.924 16 68.96 16 59.234V54.65h8.526v4.584c0 2.012 1.047 4.127 3.117 6.303V50.466H16ZM59.139 15.33l20.665 6.396v28.74H67.671v12.445s-2.713 3.556-8.525 6.534L59.14 15.33Zm12.14 26.609v-13.66l-3.608-1.114v14.774h3.607Zm0 17.927V54.65h8.525v5.216c0 14.493-21.028 22.835-27.474 25.047l-2.344.81v-9.016l1.145-.433C61.16 72.5 71.278 65.963 71.278 59.866Z"
  })));
};
/* harmony default export */ var safepal = (SvgSafepal);
;// CONCATENATED MODULE: ./src/svgs/wallet/token-pocket-wallet.svg
var token_pocket_wallet_circle, token_pocket_wallet_path, token_pocket_wallet_path2;
function token_pocket_wallet_extends() { token_pocket_wallet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return token_pocket_wallet_extends.apply(this, arguments); }

var SvgTokenPocketWallet = function SvgTokenPocketWallet(props) {
  return /*#__PURE__*/react.createElement("svg", token_pocket_wallet_extends({
    viewBox: "0 0 96 96",
    width: 32,
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    className: "token-pocket-wallet_svg__sc-bdnxRM token-pocket-wallet_svg__kDWlca"
  }, props), token_pocket_wallet_circle || (token_pocket_wallet_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#fff"
  })), token_pocket_wallet_path || (token_pocket_wallet_path = /*#__PURE__*/react.createElement("path", {
    d: "M44.329 35.355V21.713H19.093c-.512 0-.853.341-.853.853v19.268c0 .512.341.853.853.853h9.719v35.126c0 .511.341.852.852.852h15.858c.512 0 .853-.34.853-.852V35.355h-2.046Z",
    fill: "#29AEFF"
  })), token_pocket_wallet_path2 || (token_pocket_wallet_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M61.892 17.28H39.213c-.511 0-.852.34-.852.852V73.38c0 .512.34.853.852.853h15.858c.512 0 .853-.341.853-.853V59.397h6.138c11.596 0 20.974-9.378 20.974-20.973 0-11.766-9.549-21.144-21.144-21.144Z",
    fill: "#2761E7"
  })));
};
/* harmony default export */ var token_pocket_wallet = (SvgTokenPocketWallet);
;// CONCATENATED MODULE: ./src/svgs/wallet/trust-wallet.svg
function trust_wallet_extends() { trust_wallet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trust_wallet_extends.apply(this, arguments); }

var SvgTrustWallet = function SvgTrustWallet(props) {
  return /*#__PURE__*/react.createElement("svg", trust_wallet_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3375bb",
      fillOpacity: 1
    },
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14Zm0 0"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M20.871 7.066a.904.904 0 0 1 .91.922c-.043 2.606-.144 4.606-.332 6.184-.183 1.578-.46 2.75-.875 3.7a5.826 5.826 0 0 1-1.035 1.605c-.547.59-1.172 1.02-1.852 1.43-.292.171-.597.343-.91.523a34.24 34.24 0 0 0-2.273 1.379.916.916 0 0 1-1.012 0 34.492 34.492 0 0 0-2.3-1.391 45.98 45.98 0 0 1-.45-.258c-.8-.46-1.52-.906-2.148-1.539a5.487 5.487 0 0 1-1.074-1.543c-.395-.812-.66-1.797-.86-3.074-.262-1.703-.39-3.93-.441-7.016a.902.902 0 0 1 .258-.652.93.93 0 0 1 .652-.27h.375c1.16 0 3.719-.109 5.934-1.832a.914.914 0 0 1 1.117 0c2.21 1.723 4.77 1.836 5.937 1.832M18.836 17.29c.285-.586.52-1.394.703-2.562.215-1.391.344-3.282.406-5.852-1.363-.04-3.71-.3-5.945-1.809-2.238 1.504-4.582 1.766-5.945 1.809.05 2.129.144 3.781.297 5.082.175 1.477.425 2.48.738 3.184.203.468.433.804.703 1.101.363.399.824.727 1.45 1.106.257.156.546.316.855.492.554.316 1.191.676 1.898 1.125.7-.442 1.324-.797 1.871-1.11.168-.097.324-.183.473-.273.77-.441 1.34-.809 1.765-1.238.286-.293.516-.614.73-1.055"
  }));
};
/* harmony default export */ var trust_wallet = (SvgTrustWallet);
;// CONCATENATED MODULE: ./src/svgs/wallet/wallet-bsc.svg
var wallet_bsc_defs, wallet_bsc_use;
function wallet_bsc_extends() { wallet_bsc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wallet_bsc_extends.apply(this, arguments); }

var SvgWalletBsc = function SvgWalletBsc(props) {
  return /*#__PURE__*/react.createElement("svg", wallet_bsc_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 28
  }, props), wallet_bsc_defs || (wallet_bsc_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("image", {
    id: "wallet-bsc_svg__a",
    width: 219,
    height: 253,
    xlinkHref: "data:image/png;base64,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"
  }))), wallet_bsc_use || (wallet_bsc_use = /*#__PURE__*/react.createElement("use", {
    xlinkHref: "#wallet-bsc_svg__a",
    transform: "scale(.11872 .11067)"
  })));
};
/* harmony default export */ var wallet_bsc = (SvgWalletBsc);
;// CONCATENATED MODULE: ./src/svgs/wallet/wallet-connect.svg
function wallet_connect_extends() { wallet_connect_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wallet_connect_extends.apply(this, arguments); }

var SvgWalletConnect = function SvgWalletConnect(props) {
  return /*#__PURE__*/react.createElement("svg", wallet_connect_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 17
  }, props), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3b99fc",
      fillOpacity: 1
    },
    d: "M5.734 3.332c4.567-4.402 11.965-4.402 16.532 0l.55.527a.552.552 0 0 1 0 .797L20.938 6.47c-.118.11-.301.11-.415 0l-.757-.727c-3.184-3.07-8.348-3.07-11.532 0l-.808.781c-.117.11-.301.11-.414 0l-1.88-1.812a.546.546 0 0 1 0-.797Zm20.418 3.746 1.672 1.613c.23.22.23.579 0 .797l-7.543 7.27a.592.592 0 0 1-.824 0l-5.355-5.16a.146.146 0 0 0-.204 0l-5.355 5.16a.592.592 0 0 1-.824 0L.176 9.488a.546.546 0 0 1 0-.797l1.672-1.613a.605.605 0 0 1 .828 0l5.351 5.16a.151.151 0 0 0 .207 0l5.352-5.16a.605.605 0 0 1 .828 0l5.352 5.16a.151.151 0 0 0 .207 0l5.351-5.16a.605.605 0 0 1 .828 0Zm0 0"
  }));
};
/* harmony default export */ var wallet_connect = (SvgWalletConnect);
;// CONCATENATED MODULE: ./src/svgs/wallet/phantom.svg
function phantom_extends() { phantom_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phantom_extends.apply(this, arguments); }

var SvgPhantom = function SvgPhantom(props) {
  return /*#__PURE__*/react.createElement("svg", phantom_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "phantom_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#534bb1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#551bf9",
      stopOpacity: 1
    }
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "phantom_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 65.5,
    y1: 23,
    x2: 65.5,
    y2: 108,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.819608
    }
  }))), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#phantom_svg__a)"
    },
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14Zm0 0"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#phantom_svg__b)"
    },
    d: "M24.191 14.2h-2.503c0-5.063-4.149-9.169-9.27-9.169-5.055 0-9.164 4.004-9.266 8.98-.105 5.145 4.774 9.614 9.977 9.614h.656c4.582 0 10.73-3.55 11.692-7.879.175-.797-.461-1.547-1.286-1.547ZM8.7 14.425c0 .676-.558 1.23-1.246 1.23a1.24 1.24 0 0 1-1.242-1.23v-1.992c0-.676.559-1.23 1.242-1.23.688 0 1.246.554 1.246 1.23Zm4.32 0a1.24 1.24 0 0 1-1.242 1.23 1.241 1.241 0 0 1-1.246-1.23v-1.992c0-.676.563-1.23 1.246-1.23a1.24 1.24 0 0 1 1.243 1.23Zm0 0"
  }));
};
/* harmony default export */ var phantom = (SvgPhantom);
;// CONCATENATED MODULE: ./src/svgs/wallet/slope.svg
function slope_extends() { slope_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return slope_extends.apply(this, arguments); }

var SvgSlope = function SvgSlope(props) {
  return /*#__PURE__*/react.createElement("svg", slope_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "slope_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 51.983,
    y1: 7.072,
    x2: 51.983,
    y2: 76.127,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a8adff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.649,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "slope_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 76.018,
    y1: 51.958,
    x2: 76.018,
    y2: 120.928,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.261,
    style: {
      stopColor: "#b6baff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4e2ff",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#6e66fa",
      fillOpacity: 1
    },
    d: "M14 0c7.73 0 14 6.27 14 14s-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0Zm0 0"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#slope_svg__a)"
    },
    d: "m6.113 11.41 5.258-5.273 4.512-4.461a.438.438 0 0 1 .746.308v9.426l-5.258 5.242Zm0 0"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#slope_svg__b)"
    },
    d: "m21.887 16.625-5.258-5.258-5.258 5.258v9.39c0 .387.469.583.746.31Zm0 0"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#f1f0ff",
      fillOpacity: 1
    },
    d: "M6.113 11.41h3.66c.883 0 1.598.715 1.598 1.598v3.644h-3.66a1.597 1.597 0 0 1-1.598-1.597ZM16.629 11.41h3.66c.883 0 1.598.715 1.598 1.598v3.644h-3.66a1.597 1.597 0 0 1-1.598-1.597Zm0 0"
  }));
};
/* harmony default export */ var slope = (SvgSlope);
;// CONCATENATED MODULE: ./src/svgs/wallet/sollet.svg
function sollet_extends() { sollet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sollet_extends.apply(this, arguments); }

var SvgSollet = function SvgSollet(props) {
  return /*#__PURE__*/react.createElement("svg", sollet_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/react.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#00ffa3",
      fillOpacity: 1
    },
    d: "M4.695 19.703a.902.902 0 0 1 .637-.262h22c.402 0 .602.485.32.77l-4.347 4.344a.902.902 0 0 1-.637.261h-22a.452.452 0 0 1-.32-.77ZM4.695 3.484a.902.902 0 0 1 .637-.261h22c.402 0 .602.484.32.77l-4.347 4.343a.902.902 0 0 1-.637.262h-22a.452.452 0 0 1-.32-.77ZM23.305 11.574a.902.902 0 0 0-.637-.261h-22a.452.452 0 0 0-.32.769l4.347 4.344a.902.902 0 0 0 .637.262h22a.452.452 0 0 0 .32-.77Zm0 0"
  }));
};
/* harmony default export */ var sollet = (SvgSollet);
;// CONCATENATED MODULE: ./src/svgs/wallet/clover.svg
var clover_script, clover_path, clover_path2, clover_defs;
function clover_extends() { clover_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clover_extends.apply(this, arguments); }

var SvgClover = function SvgClover(props) {
  return /*#__PURE__*/react.createElement("svg", clover_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 114 114",
    fill: "none"
  }, props), clover_script || (clover_script = /*#__PURE__*/react.createElement("script", {
    type: "text/javascript"
  })), clover_path || (clover_path = /*#__PURE__*/react.createElement("path", {
    d: "M86.64 0H27.36C12.25 0 0 12.25 0 27.36v59.28C0 101.751 12.25 114 27.36 114h59.28c15.111 0 27.36-12.249 27.36-27.36V27.36C114 12.25 101.751 0 86.64 0Z",
    fill: "url(#clover_svg__a)"
  })), clover_path2 || (clover_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.999 93.48c20.147 0 36.48-16.332 36.48-36.48 0-20.147-16.333-36.48-36.48-36.48S20.519 36.853 20.519 57c0 20.148 16.333 36.48 36.48 36.48Zm-6.438-55.26c0-.294.239-.532.533-.532h11.809c.294 0 .533.238.533.533v12.477H50.562v12.604h12.874V75.78a.533.533 0 0 1-.533.533H51.094a.533.533 0 0 1-.533-.533V63.709h-12.34a.533.533 0 0 1-.534-.534V51.231c0-.294.239-.533.534-.533h12.341V38.221Zm12.875 12.478H75.78c.295 0 .534.239.534.533v11.944a.533.533 0 0 1-.534.534H63.438l-.002-13.01Z",
    fill: "#0C0B0B"
  })), clover_defs || (clover_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "clover_svg__a",
    x1: 109.25,
    y1: 5.429,
    x2: -33.25,
    y2: 167.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#BDFDE2"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#9BDAF6"
  })))));
};
/* harmony default export */ var clover = (SvgClover);
;// CONCATENATED MODULE: ./src/svgs/wallet/solflare.svg
var solflare_script, solflare_path, solflare_path2, solflare_defs;
function solflare_extends() { solflare_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solflare_extends.apply(this, arguments); }

var SvgSolflare = function SvgSolflare(props) {
  return /*#__PURE__*/react.createElement("svg", solflare_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 50 50",
    fill: "none"
  }, props), solflare_script || (solflare_script = /*#__PURE__*/react.createElement("script", {
    type: "text/javascript"
  })), solflare_path || (solflare_path = /*#__PURE__*/react.createElement("path", {
    d: "M25.17 47.91c.526 0 .951.421.951.94 0 .52-.425.94-.95.94a.946.946 0 0 1-.95-.94c0-.519.425-.94.95-.94ZM24.139 2.995a.99.99 0 0 1 .903.847l1.13 8.215c.38 2.715 3.654 3.89 5.675 2.046L43.175 3.792a.679.679 0 0 1 .95.038c.231.248.238.627.017.883l-9.88 11.396c-1.818 2.094-.476 5.364 2.296 5.597l8.717.84a.783.783 0 0 1 .71.853.784.784 0 0 1-.664.695l-9.159 1.43c-2.66.363-3.864 3.512-2.134 5.558l3.22 3.796a.716.716 0 0 1-.09 1.018.738.738 0 0 1-.915.02l-3.969-2.998c-2.142-1.61-5.23-.241-5.456 2.425l-.875 10.397a.787.787 0 0 1-.852.713.786.786 0 0 1-.717-.672l-1.387-10.044c-.372-2.714-3.646-3.89-5.675-2.046L5.26 44.665a.62.62 0 0 1-.868-.035.601.601 0 0 1-.015-.806l10.519-12.138c1.818-2.094.484-5.364-2.288-5.598l-8.719-.84a.783.783 0 0 1-.71-.853.785.785 0 0 1 .664-.695l9.153-1.43c2.66-.362 3.872-3.511 2.142-5.557l-2.192-2.584a.888.888 0 0 1 .113-1.262.915.915 0 0 1 1.133-.025l2.692 2.034c2.142 1.611 5.23.242 5.456-2.424l.724-8.56a.991.991 0 0 1 1.074-.897ZM.951 23.435c.525 0 .95.42.95.94 0 .519-.425.94-.95.94a.946.946 0 0 1-.951-.94c0-.52.426-.94.95-.94Zm47.68-.955c.524 0 .95.42.95.94s-.426.94-.95.94a.946.946 0 0 1-.951-.94c0-.52.425-.94.95-.94ZM24 0c.525 0 .95.421.95.94 0 .52-.425.94-.95.94a.945.945 0 0 1-.95-.94c0-.519.425-.94.95-.94Z",
    fill: "url(#solflare_svg__a)"
  })), solflare_path2 || (solflare_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M24.571 32.78c4.96 0 8.98-3.977 8.98-8.883 0-4.905-4.02-8.882-8.98-8.882-4.96 0-8.98 3.977-8.98 8.882 0 4.906 4.02 8.882 8.98 8.882Z",
    fill: "url(#solflare_svg__b)"
  })), solflare_defs || (solflare_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "solflare_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.99219 12.06388 -12.18114 5.04071 22.52 20.618)"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFC10B"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FB3F2E"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "solflare_svg__a",
    x1: 6.478,
    y1: 7.92,
    x2: 34.911,
    y2: 33.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFC10B"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FB3F2E"
  })))));
};
/* harmony default export */ var solflare = (SvgSolflare);
;// CONCATENATED MODULE: ./src/svgs/wallet/coin98.svg
var coin98_path;
function coin98_extends() { coin98_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return coin98_extends.apply(this, arguments); }

var SvgCoin98 = function SvgCoin98(props) {
  return /*#__PURE__*/react.createElement("svg", coin98_extends({
    viewBox: "0 0 40 40",
    color: "text",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), coin98_path || (coin98_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.133 26.658v.103a7.597 7.597 0 1 0 15.193-.103h-3.594l.001.103a4.004 4.004 0 1 1-8.006-.103H3.133Zm7.596-20.944a8.932 8.932 0 1 1 0 17.864 8.932 8.932 0 0 1 0-17.864Zm0 3.594a5.339 5.339 0 1 1 0 10.677 5.339 5.339 0 0 1 0-10.677Zm.616 3.595a1.849 1.849 0 1 1-1.232 0V11.67h1.232v1.234Zm11.401 4.052a7.597 7.597 0 1 1 13.336 0 10.758 10.758 0 0 0-3.153-1.723 4.004 4.004 0 1 0-7.028 0 10.76 10.76 0 0 0-3.155 1.723Zm6.668 17.403a8.932 8.932 0 1 0 0-17.864 8.932 8.932 0 0 0 0 17.864Zm0-3.593a5.339 5.339 0 1 0 0-10.678 5.339 5.339 0 0 0 0 10.678Zm.616-3.596a1.849 1.849 0 1 0-1.232 0v1.234h1.232V27.17Z",
    fill: "#DEAE30"
  })));
};
/* harmony default export */ var coin98 = (SvgCoin98);
;// CONCATENATED MODULE: ./src/svgs/index.ts







































































































var Icons = {
  MenuIcon: menu,
  MenuBarIcon: menu_bar,
  HunnyPokerIcon: hunnypoker,
  HunnyFarmIcon: farm,
  JarIcon: jar,
  HunnySwapIcon: hunnyswap,
  TransactionHistoryIcon: transaction_history,
  ExpandIcon: expand,
  ArrowUpIcon: arrow_up,
  ArrowDownIcon: arrow_down,
  ArrowDownIconAlt: arrow_down_alt,
  ChevronLeftIcon: chevron_left,
  ChevronRightIcon: chevron_right,
  ClearIcon: clear,
  StakeIcon: stake,
  NewIcon: svgs_new,
  NewsIcon: news,
  NewSecondary: new_secondary,
  ComingSecondary: coming_secondary,
  ReferralIcon: referral,
  CopyRightIcon: copy_right,
  CopyIcon: copy_icon,
  CopyIconOutline: copy_icon_outline,
  EmailIcon: email_default,
  CloseCircleIcon: close_circle,
  CloseStrokeIcon: close_stroke,
  CloseIcon: svgs_close,
  FullScreenIcon: fullscreen,
  UserIcon: user_icon,
  OutlinedUserIcon: user_icon_outlined,
  AddIconOutlined: add_icon,
  EditIcon: edit_icon,
  TelegramIcon: telegram,
  TwitterIcon: twitter,
  MediumIcon: medium,
  DiscordIcon: discord,
  SearchIcon: search,
  BackIcon: back,
  HomeIcon: home_outline,
  OpenPageicon: open_page_icon,
  LoginIcon: login,
  SupportIcon: support_outline,
  EyeIcon: eye,
  EyeRevealIcon: eye_reveal,
  PasswordIcon: svgs_password,
  WarningIcon: warning,
  WalletIcon: wallet,
  DateRangeIcon: date_range_icon,
  TrashbinIcon: trash_bin_icon,
  CircleLoadingBackgroundIcon: circle_loading_background,
  CircleLoadingIcon: circle_loading,
  InfoIcon: info,
  SuccessIcon: success,
  HourGlassIcon: hourglass,
  SuccessCheckIcon: success_check,
  VerifyIcon: verify,
  ProviderFilterIcon: provider_filter,
  PlayIcon: play,
  HelpOutlineIcon: help_outline,
  RotateRightIcon: rotate_right,
  RotateLeftIcon: rotate_left,
  ZoomInIcon: zoom_in,
  ZoomOutIcon: zoom_out,
  // navigation icons
  CashbackIcon: cashback,
  HusdIcon: hpd_navigation_icon,
  LogoutIcon: logout,
  /// payment
  DepositIcon: icon_deposit,
  WithdrawIcon: icon_withdraw,
  SwapIcon: icon_swap,
  // wallet icons
  Coin98: coin98,
  BitKeepIcon: bitkeep,
  MetamaskIcon: metamask_fox,
  MathWallet: math_wallet,
  SafePal: safepal,
  TokenPocket: token_pocket_wallet,
  TrustWallet: trust_wallet,
  BSCWallet: wallet_bsc,
  WalletConnect: wallet_connect,
  PhantomWallet: phantom,
  SlopeWallet: slope,
  SolletWallet: sollet,
  CloverWallet: clover,
  SolflareWallet: solflare,
  CasinoGameIcon: casino,
  SportGameIcon: sport,
  GameIcon: all_game_icon,
  BinIcon: bin,
  BlockIcon: block_icon,
  // status
  SuccessStatus: success_status,
  // flags
  ArabFlagIcon: arab,
  BrazilFlagIcon: brazil,
  ChinaFlagIcon: china,
  EnglishFlagIcon: english,
  FranceFlagIcon: france,
  HongkongFlagIcon: hongkong,
  IndoFlagIcon: indo,
  KoreaFlagIcon: korea,
  PortugalFlagIcon: portugal,
  SpainFlagIcon: spain,
  ThailandFlagIcon: thailand,
  TurkeyFlagIcon: turkey,
  VietnameseFlagIcon: vietnamese,
  JapaneseFlagIcon: japan
};
var getIcon = function getIcon(iconName) {
  return Icons[iconName];
};

/***/ }),

/***/ 82681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_E": function() { return /* binding */ breakpointMap; }
/* harmony export */ });
/* unused harmony export transitions */
var breakpointMap = {
  xs: 370,
  sm: 576,
  md: 852,
  lg: 968,
  xl: 1250,
  xxl: 1400,
  xxxl: 1600
};
var breakpoints = Object.values(breakpointMap).map(function (breakpoint) {
  return "".concat(breakpoint, "px");
});
var mediaQueries = {
  xs: "@media screen and (min-width: ".concat(breakpointMap.xs, "px)"),
  sm: "@media screen and (min-width: ".concat(breakpointMap.sm, "px)"),
  md: "@media screen and (min-width: ".concat(breakpointMap.md, "px)"),
  lg: "@media screen and (min-width: ".concat(breakpointMap.lg, "px)"),
  xl: "@media screen and (min-width: ".concat(breakpointMap.xl, "px)"),
  xxl: "@media screen and (min-width: ".concat(breakpointMap.xxl, "px)"),
  xxxl: "@media screen and (min-width: ".concat(breakpointMap.xxxl, "px)")
};
var transitions = {
  fast: 'all 0.2s',
  medium: 'all 0.5s'
};
var spacing = [0, 4, 8, 16, 24, 32, 48, 64];
var radii = {
  tiny: '4px',
  small: '8px',
  "default": '10px',
  large: '15px',
  extraLarge: '20px',
  modal: '16px'
};
var zIndices = {
  menu: 5,
  dropdown: 10,
  modal: 100
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
  siteWidth: 1328,
  topbarHeight: '65px',
  bottombarHeight: '64px',
  navigationWidth: '246px',
  breakpoints: breakpoints,
  mediaQueries: mediaQueries,
  spacing: spacing,
  radii: radii,
  transitions: transitions,
  zIndices: zIndices
});

/***/ }),

/***/ 57214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82681);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72959);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var theme = _objectSpread({
  colors: _colors__WEBPACK_IMPORTED_MODULE_2__/* .colors */ .O
}, _base__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP);

/* harmony default export */ __webpack_exports__["Z"] = (theme);

/***/ }),

/***/ 83485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fb": function() { return /* binding */ filterAllowedParams; },
/* harmony export */   "so": function() { return /* binding */ generateUrlWithQueryString; }
/* harmony export */ });
/* unused harmony export getActionUrlSearch */
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(170);
/* eslint-disable no-param-reassign */

var getActionUrlSearch = function getActionUrlSearch(query) {
  if (false) {}
  var urlParams = new URL(window.location.href);
  urlParams.searchParams.set('action', query);
  return urlParams.search;
};
var filterAllowedParams = function filterAllowedParams(params) {
  if (Object.keys(params).length) {
    var filteredParams = Object.keys(params).filter(function (key) {
      return config_constants__WEBPACK_IMPORTED_MODULE_0__/* .remainSearchParams.includes */ .L4.includes(key.toLowerCase());
    }).reduce(function (obj, key) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = params[key];
      return obj;
    }, {});
    return filteredParams;
  }

  return params;
};
var generateUrlWithQueryString = function generateUrlWithQueryString(url, params) {
  if (Object.keys(params).length) {
    var filteredParams = filterAllowedParams(params);

    if (Object.keys(filteredParams).length) {
      if (url[0] !== '/') url = "/".concat(url);
      return "".concat(url, "?").concat(serialize(filteredParams));
    }

    return url;
  }

  return url;
};

var serialize = function serialize(obj) {
  return Object.keys(obj).reduce(function (state, key) {
    state.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key].toString())));
    return state;
  }, []).join('&');
};

/***/ })

}]);